/* eslint-disable */
import { useMutation, useQuery } from '@tanstack/react-query';
import type { QueryKey, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';

import { courseFetcher } from '../Fetcher';
import type { RequestOptions } from '../Fetcher';
const fetcher = courseFetcher;

export type Maybe<T> = T | null;

export type OneOf<T> = T extends unknown[]
  ? T[number]
  : T extends readonly unknown[]
    ? T[number]
    : T;

export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]-?: Exclude<T[K], undefined>;
};

export type Values<T extends Record<string, unknown>> = T extends Record<string, infer U>
  ? U
  : T extends { [key: string]: infer U }
    ? U
    : never;

export const enum ResponseStatus {
  OK = 'OK',
  SERVER_ERROR = 'SERVER_ERROR',
  DUPLICATE = 'DUPLICATE',
  NOT_FOUND = 'NOT_FOUND',
  BAD_REQUEST = 'BAD_REQUEST',
  BAD_PARAMETER = 'BAD_PARAMETER',
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
}

export type Success<T = unknown> = {
  statusCode: ResponseStatus.OK;
  message: '';
  data: T;
  errorCode: string;
};

export type Error = {
  statusCode: Omit<keyof typeof ResponseStatus, 'OK'>;
  message: string;
  data: Maybe<''>;
  errorCode: string;
};

/**
 * @typeParam T - Response data type
 */
export type ApiResponse<T = unknown> = Success<T>;

export const API_ENDPOINT = {
  CLIENT_V1_VOUCHERS_ENROLLMENT_VERIFICATIONS_CONFIRM:
    '/client/api/v1/vouchers/enrollment-verifications/confirm',
  CLIENT_V1_VOUCHER_ARCHIVE: '/client/api/v1/voucher/archive',
  CLIENT_V1_MY_LISTS: '/client/api/v1/my-lists',
  CLIENT_V1_EXPERT_PROPOSALS_ME_PROPOSALID: (proposalId: string) =>
    `/client/api/v1/expert-proposals/me/${proposalId}`,
  CLIENT_V1_EXPERT_PROFILES: '/client/api/v1/expert-profiles',
  CLIENT_V1_EXPERT_OFFERINGS_EXPERTOFFERINGID: (expertOfferingId: string) =>
    `/client/api/v1/expert-offerings/${expertOfferingId}`,
  CLIENT_V1_EXPERT_OFFERINGS_EXPERTOFFERINGID_BOOKMARK: (expertOfferingId: string) =>
    `/client/api/v1/expert-offerings/${expertOfferingId}/bookmark`,
  CLIENT_V1_EXPERT_OFFERINGS_ME_EXPERTOFFERINGID_PUBLISH: (expertOfferingId: string) =>
    `/client/api/v1/expert-offerings/me/${expertOfferingId}/publish`,
  CLIENT_V1_EXPERT_OFFERINGS_ME_EXPERTOFFERINGID_PAUSE: (expertOfferingId: string) =>
    `/client/api/v1/expert-offerings/me/${expertOfferingId}/pause`,
  CLIENT_V1_EXPERT_OFFERING_VOUCHERS_ID_CANCEL: (id: number) =>
    `/client/api/v1/expert-offering-vouchers/${id}/cancel`,
  CLIENT_V1_COURSE_CERTIFICATES_CONFIRM: '/client/api/v1/course-certificates/confirm',
  CLIENT_V1_ROULETTE_DRAW: '/client/api/v1/roulette/draw',
  CLIENT_V1_MY_LISTS_SEQUENCE: '/client/api/v1/my-lists/sequence',
  CLIENT_V1_MY_LISTS_COURSE_SEQUENCE: '/client/api/v1/my-lists/course/sequence',
  CLIENT_V1_MY_LISTS_COURSE: '/client/api/v1/my-lists/course',
  CLIENT_V1_MARKETING_PARTNERS: '/client/api/v1/marketing-partners',
  CLIENT_V1_MARKETING_PARTNER_LINKS: '/client/api/v1/marketing-partner-links',
  CLIENT_V1_EXPERT_PROPOSALS_ME_PROPOSALID_WITHDRAW: (proposalId: string) =>
    `/client/api/v1/expert-proposals/me/${proposalId}/withdraw`,
  CLIENT_V1_EXPERT_PROJECTS: '/client/api/v1/expert-projects',
  CLIENT_V1_EXPERT_PROJECTS_PROJECTID_PROPOSALS: (projectId: string) =>
    `/client/api/v1/expert-projects/${projectId}/proposals`,
  CLIENT_V1_EXPERT_PROJECTS_ME_PROJECTID_PROPOSALS_PROPOSALID_ACCEPT: (
    projectId: string,
    proposalId: string,
  ) => `/client/api/v1/expert-projects/me/${projectId}/proposals/${proposalId}/accept`,
  CLIENT_V1_EXPERT_PROJECTS_ME_PROJECTID_CANCEL: (projectId: string) =>
    `/client/api/v1/expert-projects/me/${projectId}/cancel`,
  CLIENT_V1_EXPERT_OFFERINGS: '/client/api/v1/expert-offerings',
  CLIENT_V1_EXPERT_OFFERINGS_EXPERTOFFERINGID_REVIEWS: (expertOfferingId: string) =>
    `/client/api/v1/expert-offerings/${expertOfferingId}/reviews`,
  CLIENT_V1_EXPERT_OFFERINGS_IMAGES_UPLOAD_URLS:
    '/client/api/v1/expert-offerings/images/upload-urls',
  CLIENT_V1_EXPERT_OFFERING_ORDERS: '/client/api/v1/expert-offering-orders',
  CLIENT_V1_COURSE_COURSEID_LIKE: (courseId: string) => `/client/api/v1/course/${courseId}/like`,
  CLIENT_V1_CART: '/client/api/v1/cart',
  CLIENT_V1_AX_INQUIRIES: '/client/api/v1/ax-inquiries',
  CLIENT_V2_VOUCHERS_MY: '/client/api/v2/vouchers/my',
  CLIENT_V2_VOUCHERS_ENROLLMENT_VERIFICATIONS: '/client/api/v2/vouchers/enrollment-verifications',
  CLIENT_V2_SKILLS_SEARCH: '/client/api/v2/skills/search',
  CLIENT_V2_MY_LISTS_ID: (id: string) => `/client/api/v2/my-lists/${id}`,
  CLIENT_V1_VOUCHERS_MY_UPCOMING_EVENTS: '/client/api/v1/vouchers/my/upcoming-events',
  CLIENT_V1_VOUCHER_MY_CHALLENGES: '/client/api/v1/voucher/my/challenges',
  CLIENT_V1_USER_STATISTICS: '/client/api/v1/user-statistics',
  CLIENT_V1_ROULETTE_RESULTS: '/client/api/v1/roulette/results',
  CLIENT_V1_ROADMAP_AUTHOR_USERID: (userId: string) => `/client/api/v1/roadmap/author/${userId}`,
  CLIENT_V1_ORDER_SUMMARIES: '/client/api/v1/order/summaries',
  CLIENT_V1_MY_LISTS_ID: (id: string) => `/client/api/v1/my-lists/${id}`,
  CLIENT_V1_MARKETING_PARTNERS_COURSES_SEARCH: '/client/api/v1/marketing-partners/courses/search',
  CLIENT_V1_MARKETING_PARTNER_LINKS_CREATE_PREVIEW:
    '/client/api/v1/marketing-partner-links/create/preview',
  CLIENT_V1_EXPERT_PROPOSALS_ME: '/client/api/v1/expert-proposals/me',
  CLIENT_V1_EXPERT_PROJECTS_PROJECTID: (projectId: string) =>
    `/client/api/v1/expert-projects/${projectId}`,
  CLIENT_V1_EXPERT_PROJECTS_ME: '/client/api/v1/expert-projects/me',
  CLIENT_V1_EXPERT_PROJECTS_ME_PROJECTID: (projectId: string) =>
    `/client/api/v1/expert-projects/me/${projectId}`,
  CLIENT_V1_EXPERT_PROJECTS_ME_PROJECTID_PROPOSALS: (projectId: string) =>
    `/client/api/v1/expert-projects/me/${projectId}/proposals`,
  CLIENT_V1_EXPERT_PROJECTS_ME_PROJECTID_PROPOSALS_PROPOSALID: (
    projectId: string,
    proposalId: string,
  ) => `/client/api/v1/expert-projects/me/${projectId}/proposals/${proposalId}`,
  CLIENT_V1_EXPERT_OFFERINGS_ME: '/client/api/v1/expert-offerings/me',
  CLIENT_V1_EXPERT_OFFERING_VOUCHERS_RECEIVED: '/client/api/v1/expert-offering-vouchers/received',
  CLIENT_V1_EXPERT_OFFERING_ORDERS_ORDERID: (orderId: number) =>
    `/client/api/v1/expert-offering-orders/${orderId}`,
  CLIENT_V1_COURSES_ID_SIMPLE: (id: string) => `/client/api/v1/courses/${id}/simple`,
  CLIENT_V1_COURSES_COURSEID_PAYMENT_INFO: (courseId: string) =>
    `/client/api/v1/courses/${courseId}/payment-info`,
  CLIENT_V1_COURSES_TOP: '/client/api/v1/courses/top',
  CLIENT_V1_COURSES_SUBSCRIPTION: '/client/api/v1/courses/subscription',
  CLIENT_V1_COURSE_USER_USERID: (userId: string) => `/client/api/v1/course/user/${userId}`,
  CLIENT_V1_COURSE_LIKES: '/client/api/v1/course/likes',
  CLIENT_V1_COURSE_GIFTS_SENT: '/client/api/v1/course-gifts/sent',
  CLIENT_V1_COURSE_GIFTS_RECEIVED: '/client/api/v1/course-gifts/received',
  CLIENT_V1_COURSE_CERTIFICATES: '/client/api/v1/course-certificates',
  CLIENT_V1_COURSE_CERTIFICATES_UNCONFIRMED: '/client/api/v1/course-certificates/unconfirmed',
  CLIENT_V1_COURSE_CERTIFICATES_DETAIL: '/client/api/v1/course-certificates/detail',
  CLIENT_V1_COURSE_CERTIFICATES_CHALLENGE_DETAIL:
    '/client/api/v1/course-certificates/challenge/detail',
  CLIENT_V1_CATEGORY_MAIN: '/client/api/v1/category/main',
  CLIENT_V1_VOUCHERS_ID_FREE: (id: string) => `/client/api/v1/vouchers/${id}/free`,
  CLIENT_V1_EXPERT_OFFERINGS_ME_EXPERTOFFERINGID: (expertOfferingId: string) =>
    `/client/api/v1/expert-offerings/me/${expertOfferingId}`,
};

export function useClientApiV1VouchersEnrollmentVerificationsConfirmUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateResponse,
    unknown,
    ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateResponse,
    unknown,
    ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateVariables =
  ConfirmEnrollmentVerificationRequest;

export type ClientApiV1VouchersEnrollmentVerificationsConfirmUpdateResponse = EmptyOkResponse;

export function useClientApiV1VoucherArchiveUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1VoucherArchiveUpdateResponse,
    unknown,
    ClientApiV1VoucherArchiveUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1VoucherArchiveUpdateResponse,
    unknown,
    ClientApiV1VoucherArchiveUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1VoucherArchiveUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1VoucherArchiveUpdateVariables = ArchiveVoucherV2Request;

export type ClientApiV1VoucherArchiveUpdateResponse = EmptyOkResponse;

export const fetchClientApiV1MyLists = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV1MyListsResponse>(url, requestOptions);

export interface ClientApiV1MyListsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1MyListsResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1MyListsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1MyListsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1MyLists(url, requestOptions),
  ...options,
});

export function useClientApiV1MyListsQuery(params: ClientApiV1MyListsQueryParams) {
  const result = useQuery<ClientApiV1MyListsResponse, unknown>(
    getClientApiV1MyListsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsResponse = ApiResponseListFindMyListResponse;

export function useClientApiV1MyListsUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsUpdateResponse,
    unknown,
    ClientApiV1MyListsUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsUpdateResponse,
    unknown,
    ClientApiV1MyListsUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsUpdateVariables = UpdateMyListRequest;

export type ClientApiV1MyListsUpdateResponse = EmptyOkResponse;

export function useClientApiV1MyListsCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsCreateResponse,
    unknown,
    ClientApiV1MyListsCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsCreateResponse,
    unknown,
    ClientApiV1MyListsCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsCreateVariables = CreateMyListRequest;

export type ClientApiV1MyListsCreateResponse = EmptyOkResponse;

export const fetchClientApiV1ExpertProposalsMeProposalId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProposalsMeProposalIdResponse>(url, requestOptions);

export interface ClientApiV1ExpertProposalsMeProposalIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProposalsMeProposalIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProposalsMeProposalIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProposalsMeProposalIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProposalsMeProposalId(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProposalsMeProposalIdQuery(
  params: ClientApiV1ExpertProposalsMeProposalIdQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProposalsMeProposalIdResponse, unknown>(
    getClientApiV1ExpertProposalsMeProposalIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProposalsMeProposalIdResponse =
  ApiResponseGetMyExpertProjectProposalResponse;

export function useClientApiV1ExpertProposalsMeProposalIdUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProposalsMeProposalIdUpdateResponse,
    unknown,
    ClientApiV1ExpertProposalsMeProposalIdUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProposalsMeProposalIdUpdateResponse,
    unknown,
    ClientApiV1ExpertProposalsMeProposalIdUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProposalsMeProposalIdUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProposalsMeProposalIdUpdateVariables =
  SubmitExpertProjectProposalRequest;

export type ClientApiV1ExpertProposalsMeProposalIdUpdateResponse = EmptyOkResponse;

export const fetchClientApiV1ExpertProfiles = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProfilesResponse>(url, requestOptions);

export interface ClientApiV1ExpertProfilesQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProfilesResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProfilesQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProfilesQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProfiles(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProfilesQuery(params: ClientApiV1ExpertProfilesQueryParams) {
  const result = useQuery<ClientApiV1ExpertProfilesResponse, unknown>(
    getClientApiV1ExpertProfilesQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProfilesResponse = ApiResponseGetExpertProfileResponse;

export function useClientApiV1ExpertProfilesUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProfilesUpdateResponse,
    unknown,
    ClientApiV1ExpertProfilesUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProfilesUpdateResponse,
    unknown,
    ClientApiV1ExpertProfilesUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProfilesUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProfilesUpdateVariables = UpdateExpertProfileRequest;

export type ClientApiV1ExpertProfilesUpdateResponse = Unit;

export function useClientApiV1ExpertProfilesCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProfilesCreateResponse,
    unknown,
    ClientApiV1ExpertProfilesCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProfilesCreateResponse,
    unknown,
    ClientApiV1ExpertProfilesCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProfilesCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProfilesCreateVariables = ApplyExpertProfileRequest;

export type ClientApiV1ExpertProfilesCreateResponse = ApiResponseApplyExpertProfileResponse;

export const fetchClientApiV1ExpertOfferingsExpertOfferingId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertOfferingsExpertOfferingIdResponse>(url, requestOptions);

export interface ClientApiV1ExpertOfferingsExpertOfferingIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertOfferingsExpertOfferingIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertOfferingsExpertOfferingIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertOfferingsExpertOfferingIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertOfferingsExpertOfferingId(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertOfferingsExpertOfferingIdQuery(
  params: ClientApiV1ExpertOfferingsExpertOfferingIdQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertOfferingsExpertOfferingIdResponse, unknown>(
    getClientApiV1ExpertOfferingsExpertOfferingIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsExpertOfferingIdResponse =
  ApiResponseGetExpertOfferingResponse;

export function useClientApiV1ExpertOfferingsExpertOfferingIdUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsExpertOfferingIdUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsExpertOfferingIdUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsExpertOfferingIdUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsExpertOfferingIdUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsExpertOfferingIdUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsExpertOfferingIdUpdateVariables = UpdateExpertOfferingRequest;

export type ClientApiV1ExpertOfferingsExpertOfferingIdUpdateResponse =
  ApiResponseGetExpertOfferingResponse;

export function useClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateVariables =
  UpdateExpertOfferingBookmarkRequest;

export type ClientApiV1ExpertOfferingsExpertOfferingIdBookmarkUpdateResponse = EmptyOkResponse;

export function useClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateResponse = EmptyOkResponse;

export type ClientApiV1ExpertOfferingsMeExpertOfferingIdPublishUpdateVariables = unknown;

export function useClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateResponse = EmptyOkResponse;

export type ClientApiV1ExpertOfferingsMeExpertOfferingIdPauseUpdateVariables = unknown;

export function useClientApiV1ExpertOfferingVouchersIdCancelUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingVouchersIdCancelUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingVouchersIdCancelUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingVouchersIdCancelUpdateResponse,
    unknown,
    ClientApiV1ExpertOfferingVouchersIdCancelUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingVouchersIdCancelUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingVouchersIdCancelUpdateVariables =
  CancelExpertOfferingVoucherRequest;

export type ClientApiV1ExpertOfferingVouchersIdCancelUpdateResponse = EmptyOkResponse;

export function useClientApiV1CourseCertificatesConfirmUpdateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1CourseCertificatesConfirmUpdateResponse,
    unknown,
    ClientApiV1CourseCertificatesConfirmUpdateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1CourseCertificatesConfirmUpdateResponse,
    unknown,
    ClientApiV1CourseCertificatesConfirmUpdateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1CourseCertificatesConfirmUpdateVariables) =>
      fetcher.put(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseCertificatesConfirmUpdateVariables = ConfirmCourseCertificateRequestV2;

export type ClientApiV1CourseCertificatesConfirmUpdateResponse =
  ApiResponseConfirmCourseCertificateResponse;

export function useClientApiV1RouletteDrawCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1RouletteDrawCreateResponse,
    unknown,
    ClientApiV1RouletteDrawCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1RouletteDrawCreateResponse,
    unknown,
    ClientApiV1RouletteDrawCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1RouletteDrawCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1RouletteDrawCreateResponse = ApiResponseRouletteDrawResponse;

export type ClientApiV1RouletteDrawCreateVariables = unknown;

export function useClientApiV1MyListsSequenceCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsSequenceCreateResponse,
    unknown,
    ClientApiV1MyListsSequenceCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsSequenceCreateResponse,
    unknown,
    ClientApiV1MyListsSequenceCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsSequenceCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsSequenceCreateVariables = UpdateMyListsSequenceRequest;

export type ClientApiV1MyListsSequenceCreateResponse = EmptyOkResponse;

export function useClientApiV1MyListsCourseSequenceCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsCourseSequenceCreateResponse,
    unknown,
    ClientApiV1MyListsCourseSequenceCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsCourseSequenceCreateResponse,
    unknown,
    ClientApiV1MyListsCourseSequenceCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsCourseSequenceCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsCourseSequenceCreateVariables = UpdateMyListCourseSequenceRequest;

export type ClientApiV1MyListsCourseSequenceCreateResponse = EmptyOkResponse;

export const fetchClientApiV1MyListsCourse = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV1MyListsCourseResponse>(url, requestOptions);

export interface ClientApiV1MyListsCourseQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1MyListsCourseResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1MyListsCourseQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1MyListsCourseQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1MyListsCourse(url, requestOptions),
  ...options,
});

export function useClientApiV1MyListsCourseQuery(params: ClientApiV1MyListsCourseQueryParams) {
  const result = useQuery<ClientApiV1MyListsCourseResponse, unknown>(
    getClientApiV1MyListsCourseQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 강의 기반 강의폴더 조회 */
export type ClientApiV1MyListsCourseQueryString = Partial<{
  courseId: number;
}>;

export type ClientApiV1MyListsCourseResponse = ApiResponseFindMyListByCourseResponse;

export function useClientApiV1MyListsCourseCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsCourseCreateResponse,
    unknown,
    ClientApiV1MyListsCourseCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsCourseCreateResponse,
    unknown,
    ClientApiV1MyListsCourseCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsCourseCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsCourseCreateVariables = AddCourseRequest;

export type ClientApiV1MyListsCourseCreateResponse = EmptyOkResponse;

export function useClientApiV1MyListsCourseDeleteMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsCourseDeleteResponse,
    unknown,
    ClientApiV1MyListsCourseDeleteVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsCourseDeleteResponse,
    unknown,
    ClientApiV1MyListsCourseDeleteVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsCourseDeleteVariables) =>
      fetcher.delete(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsCourseDeleteVariables = RemoveCourseRequest;

export type ClientApiV1MyListsCourseDeleteResponse = EmptyOkResponse;

export function useClientApiV1MarketingPartnersCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MarketingPartnersCreateResponse,
    unknown,
    ClientApiV1MarketingPartnersCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MarketingPartnersCreateResponse,
    unknown,
    ClientApiV1MarketingPartnersCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MarketingPartnersCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MarketingPartnersCreateVariables = SignupMarketingPartnerRequest;

export type ClientApiV1MarketingPartnersCreateResponse = ApiResponseSignupMarketingPartnerResponse;

export function useClientApiV1MarketingPartnerLinksCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MarketingPartnerLinksCreateResponse,
    unknown,
    ClientApiV1MarketingPartnerLinksCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MarketingPartnerLinksCreateResponse,
    unknown,
    ClientApiV1MarketingPartnerLinksCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MarketingPartnerLinksCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MarketingPartnerLinksCreateVariables = CreateMarketingPartnerLinkRequest;

export type ClientApiV1MarketingPartnerLinksCreateResponse =
  ApiResponseCreateMarketingPartnerLinkResponse;

export function useClientApiV1ExpertProposalsMeProposalIdWithdrawCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateResponse,
    unknown,
    ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateResponse,
    unknown,
    ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateResponse = EmptyOkResponse;

export type ClientApiV1ExpertProposalsMeProposalIdWithdrawCreateVariables = unknown;

export const fetchClientApiV1ExpertProjects = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProjectsResponse>(url, requestOptions);

export interface ClientApiV1ExpertProjectsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProjectsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProjectsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProjectsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProjects(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProjectsQuery(params: ClientApiV1ExpertProjectsQueryParams) {
  const result = useQuery<ClientApiV1ExpertProjectsResponse, unknown>(
    getClientApiV1ExpertProjectsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 모집 중인 AX 의뢰 목록 조회 (비로그인 허용, 패키지 필터·정렬). 패키지별 개수는 필터와 무관하게 센다. 로그인한 전문가가 지원한 의뢰는 myProposal 을 담는다. 회사 정보는 내려가지 않는다 */
export type ClientApiV1ExpertProjectsQueryString = Partial<{
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  sort: 'LATEST' | 'BUDGET_DESC' | 'FEWEST_PROPOSALS';
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertProjectsResponse = ApiResponseSearchOpenExpertProjectsResponse;

export function useClientApiV1ExpertProjectsCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProjectsCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProjectsCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProjectsCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsCreateVariables = SubmitExpertProjectRequest;

export type ClientApiV1ExpertProjectsCreateResponse = ApiResponseSubmitExpertProjectResponse;

export function useClientApiV1ExpertProjectsProjectIdProposalsCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProjectsProjectIdProposalsCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsProjectIdProposalsCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProjectsProjectIdProposalsCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsProjectIdProposalsCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProjectsProjectIdProposalsCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsProjectIdProposalsCreateVariables =
  SubmitExpertProjectProposalRequest;

export type ClientApiV1ExpertProjectsProjectIdProposalsCreateResponse =
  ApiResponseSubmitExpertProjectProposalResponse;

export function useClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateMutation<
  TContext,
>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateVariables,
    TContext
  >({
    mutationFn: (
      variables: ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateVariables,
    ) => fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateVariables =
  AcceptExpertProjectProposalRequest;

export type ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdAcceptCreateResponse =
  EmptyOkResponse;

export function useClientApiV1ExpertProjectsMeProjectIdCancelCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertProjectsMeProjectIdCancelCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsMeProjectIdCancelCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertProjectsMeProjectIdCancelCreateResponse,
    unknown,
    ClientApiV1ExpertProjectsMeProjectIdCancelCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertProjectsMeProjectIdCancelCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsMeProjectIdCancelCreateResponse = EmptyOkResponse;

export type ClientApiV1ExpertProjectsMeProjectIdCancelCreateVariables = unknown;

export const fetchClientApiV1ExpertOfferings = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertOfferingsResponse>(url, requestOptions);

export interface ClientApiV1ExpertOfferingsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertOfferingsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertOfferingsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertOfferingsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertOfferings(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertOfferingsQuery(params: ClientApiV1ExpertOfferingsQueryParams) {
  const result = useQuery<ClientApiV1ExpertOfferingsResponse, unknown>(
    getClientApiV1ExpertOfferingsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 승인된 AX 전문가의 서비스 목록 조회 (비로그인 허용, 최신순·가격순 정렬) */
export type ClientApiV1ExpertOfferingsQueryString = Partial<{
  sort: 'LATEST' | 'LOWEST_PRICE' | 'HIGHEST_PRICE';
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertOfferingsResponse = ApiResponseSearchExpertOfferingsResponse;

export function useClientApiV1ExpertOfferingsCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsCreateResponse,
    unknown,
    ClientApiV1ExpertOfferingsCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsCreateResponse,
    unknown,
    ClientApiV1ExpertOfferingsCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsCreateVariables = CreateExpertOfferingRequest;

export type ClientApiV1ExpertOfferingsCreateResponse = ApiResponseGetExpertOfferingResponse;

export const fetchClientApiV1ExpertOfferingsExpertOfferingIdReviews = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertOfferingsExpertOfferingIdReviewsResponse>(url, requestOptions);

export interface ClientApiV1ExpertOfferingsExpertOfferingIdReviewsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertOfferingsExpertOfferingIdReviewsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertOfferingsExpertOfferingIdReviewsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertOfferingsExpertOfferingIdReviewsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertOfferingsExpertOfferingIdReviews(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertOfferingsExpertOfferingIdReviewsQuery(
  params: ClientApiV1ExpertOfferingsExpertOfferingIdReviewsQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertOfferingsExpertOfferingIdReviewsResponse, unknown>(
    getClientApiV1ExpertOfferingsExpertOfferingIdReviewsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** AX 전문가 서비스 후기 목록 조회 (비로그인 허용, 최신순). 볼 수 없는 서비스면 NOT_FOUND */
export type ClientApiV1ExpertOfferingsExpertOfferingIdReviewsQueryString = Partial<{
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertOfferingsExpertOfferingIdReviewsResponse =
  ApiResponseSearchExpertOfferingReviewsResponse;

export function useClientApiV1ExpertOfferingsImagesUploadUrlsCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsImagesUploadUrlsCreateResponse,
    unknown,
    ClientApiV1ExpertOfferingsImagesUploadUrlsCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsImagesUploadUrlsCreateResponse,
    unknown,
    ClientApiV1ExpertOfferingsImagesUploadUrlsCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsImagesUploadUrlsCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsImagesUploadUrlsCreateVariables =
  CreateExpertOfferingImageUploadUrlsRequest;

export type ClientApiV1ExpertOfferingsImagesUploadUrlsCreateResponse =
  ApiResponseCreateExpertOfferingImageUploadUrlsResponse;

export function useClientApiV1ExpertOfferingOrdersCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingOrdersCreateResponse,
    unknown,
    ClientApiV1ExpertOfferingOrdersCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingOrdersCreateResponse,
    unknown,
    ClientApiV1ExpertOfferingOrdersCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingOrdersCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingOrdersCreateVariables = CreateExpertOfferingOrderRequest;

export type ClientApiV1ExpertOfferingOrdersCreateResponse =
  ApiResponseCreateExpertOfferingOrderResponse;

export function useClientApiV1CourseCourseIdLikeCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1CourseCourseIdLikeCreateResponse,
    unknown,
    ClientApiV1CourseCourseIdLikeCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1CourseCourseIdLikeCreateResponse,
    unknown,
    ClientApiV1CourseCourseIdLikeCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1CourseCourseIdLikeCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseCourseIdLikeCreateResponse = EmptyOkResponse;

export type ClientApiV1CourseCourseIdLikeCreateVariables = unknown;

export function useClientApiV1CourseCourseIdLikeDeleteMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1CourseCourseIdLikeDeleteResponse,
    unknown,
    ClientApiV1CourseCourseIdLikeDeleteVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1CourseCourseIdLikeDeleteResponse,
    unknown,
    ClientApiV1CourseCourseIdLikeDeleteVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1CourseCourseIdLikeDeleteVariables) =>
      fetcher.delete(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseCourseIdLikeDeleteResponse = EmptyOkResponse;

export type ClientApiV1CourseCourseIdLikeDeleteVariables = unknown;

export const fetchClientApiV1Cart = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV1CartResponse>(url, requestOptions);

export interface ClientApiV1CartQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CartResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CartQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CartQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1Cart(url, requestOptions),
  ...options,
});

export function useClientApiV1CartQuery(params: ClientApiV1CartQueryParams) {
  const result = useQuery<ClientApiV1CartResponse, unknown>(getClientApiV1CartQueryOptions(params));

  return { ...result, data: result.data?.data };
}

/** 클라이언트 장바구니 아이템을 조회한다. */
export type ClientApiV1CartQueryString = Partial<{
  lang: string;
}>;

export type ClientApiV1CartResponse = ApiResponseFindClientCartResponse;

export function useClientApiV1CartCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1CartCreateResponse,
    unknown,
    ClientApiV1CartCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1CartCreateResponse,
    unknown,
    ClientApiV1CartCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1CartCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CartCreateVariables = AddCartsRequest;

export type ClientApiV1CartCreateResponse = ApiResponseAddCartsResponse;

export function useClientApiV1CartDeleteMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1CartDeleteResponse,
    unknown,
    ClientApiV1CartDeleteVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1CartDeleteResponse,
    unknown,
    ClientApiV1CartDeleteVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1CartDeleteVariables) =>
      fetcher.delete(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CartDeleteVariables = RemoveCartsRequest;

export type ClientApiV1CartDeleteResponse = EmptyOkResponse;

export function useClientApiV1AxInquiriesCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1AxInquiriesCreateResponse,
    unknown,
    ClientApiV1AxInquiriesCreateVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1AxInquiriesCreateResponse,
    unknown,
    ClientApiV1AxInquiriesCreateVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1AxInquiriesCreateVariables) =>
      fetcher.post(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1AxInquiriesCreateVariables = SubmitAxInquiryRequest;

export type ClientApiV1AxInquiriesCreateResponse = EmptyOkResponse;

export const fetchClientApiV2VouchersMy = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV2VouchersMyResponse>(url, requestOptions);

export interface ClientApiV2VouchersMyQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV2VouchersMyResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV2VouchersMyQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV2VouchersMyQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV2VouchersMy(url, requestOptions),
  ...options,
});

export function useClientApiV2VouchersMyQuery(params: ClientApiV2VouchersMyQueryParams) {
  const result = useQuery<ClientApiV2VouchersMyResponse, unknown>(
    getClientApiV2VouchersMyQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 오프셋기반 페이지네이션 보유한 강의 조회 API */
export type ClientApiV2VouchersMyQueryString = Partial<{
  userId: number;
  searchKeyword: string;
  courseType: 'ON' | 'OFF' | 'CHALLENGE';
  studying: 'STUDYING' | 'COMPLETED';
  isReviewable: boolean;
  isExcludeExpired: boolean;
  isArchived: boolean;
  sort: 'COURSE_TITLE' | 'RECENT_STUDYING' | 'RECENT_APPLY' | 'EARLIEST_EXPIRATION';
  pageNumber: number;
  pageSize: number;
  lang: string;
}>;

export type ClientApiV2VouchersMyResponse = ApiResponseOffsetPageResponseMyVoucherDto;

export const fetchClientApiV2VouchersEnrollmentVerifications = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV2VouchersEnrollmentVerificationsResponse>(url, requestOptions);

export interface ClientApiV2VouchersEnrollmentVerificationsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV2VouchersEnrollmentVerificationsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV2VouchersEnrollmentVerificationsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV2VouchersEnrollmentVerificationsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV2VouchersEnrollmentVerifications(url, requestOptions),
  ...options,
});

export function useClientApiV2VouchersEnrollmentVerificationsQuery(
  params: ClientApiV2VouchersEnrollmentVerificationsQueryParams,
) {
  const result = useQuery<ClientApiV2VouchersEnrollmentVerificationsResponse, unknown>(
    getClientApiV2VouchersEnrollmentVerificationsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 수강확인증 목록 조회 API */
export type ClientApiV2VouchersEnrollmentVerificationsQueryString = Partial<{
  requester: Requester;
  userId: number;
  lang: string;
}>;

export type ClientApiV2VouchersEnrollmentVerificationsResponse =
  ApiResponseListGetEnrollmentVerificationResponse;

export const fetchClientApiV2SkillsSearch = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV2SkillsSearchResponse>(url, requestOptions);

export interface ClientApiV2SkillsSearchQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV2SkillsSearchResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV2SkillsSearchQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV2SkillsSearchQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV2SkillsSearch(url, requestOptions),
  ...options,
});

export function useClientApiV2SkillsSearchQuery(params: ClientApiV2SkillsSearchQueryParams) {
  const result = useQuery<ClientApiV2SkillsSearchResponse, unknown>(
    getClientApiV2SkillsSearchQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV2SkillsSearchQueryString = Partial<{
  keyword: string;
  types: string[][];
  size: number;
  categories: string[][];
  lang: string;
}>;

export type ClientApiV2SkillsSearchResponse = ApiResponseSearchSkillResponse;

export const fetchClientApiV2MyListsId = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV2MyListsIdResponse>(url, requestOptions);

export interface ClientApiV2MyListsIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV2MyListsIdResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV2MyListsIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV2MyListsIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV2MyListsId(url, requestOptions),
  ...options,
});

export function useClientApiV2MyListsIdQuery(params: ClientApiV2MyListsIdQueryParams) {
  const result = useQuery<ClientApiV2MyListsIdResponse, unknown>(
    getClientApiV2MyListsIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 강의폴더에 속한 강의 리스트 조회 */
export type ClientApiV2MyListsIdQueryString = Partial<{
  lang: string;
}>;

export type ClientApiV2MyListsIdResponse = ApiResponseFindMyListCoursesResponse;

export const fetchClientApiV1VouchersMyUpcomingEvents = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1VouchersMyUpcomingEventsResponse>(url, requestOptions);

export interface ClientApiV1VouchersMyUpcomingEventsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1VouchersMyUpcomingEventsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1VouchersMyUpcomingEventsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1VouchersMyUpcomingEventsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1VouchersMyUpcomingEvents(url, requestOptions),
  ...options,
});

export function useClientApiV1VouchersMyUpcomingEventsQuery(
  params: ClientApiV1VouchersMyUpcomingEventsQueryParams,
) {
  const result = useQuery<ClientApiV1VouchersMyUpcomingEventsResponse, unknown>(
    getClientApiV1VouchersMyUpcomingEventsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 내학습 > 도래할 이벤트 조회 API */
export type ClientApiV1VouchersMyUpcomingEventsQueryString = Partial<{
  courseType: 'ON' | 'OFF' | 'CHALLENGE';
  courseId: number;
  lang: string;
}>;

export type ClientApiV1VouchersMyUpcomingEventsResponse = ApiResponseFindMyUpcomingEventsResponse;

export const fetchClientApiV1VoucherMyChallenges = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1VoucherMyChallengesResponse>(url, requestOptions);

export interface ClientApiV1VoucherMyChallengesQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1VoucherMyChallengesResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1VoucherMyChallengesQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1VoucherMyChallengesQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1VoucherMyChallenges(url, requestOptions),
  ...options,
});

export function useClientApiV1VoucherMyChallengesQuery(
  params: ClientApiV1VoucherMyChallengesQueryParams,
) {
  const result = useQuery<ClientApiV1VoucherMyChallengesResponse, unknown>(
    getClientApiV1VoucherMyChallengesQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 오프셋기반 페이지네이션 보유한 챌린지 강의 조회 API */
export type ClientApiV1VoucherMyChallengesQueryString = Partial<{
  userId: number;
  searchKeyword: string;
  studying: 'STUDYING';
  isReviewable: boolean;
  isArchived: boolean;
  pageSize: number;
  pageNumber: number;
  sort: 'COURSE_TITLE' | 'RECENT_STUDYING' | 'RECENT_APPLY';
  lang: string;
}>;

export type ClientApiV1VoucherMyChallengesResponse =
  ApiResponseOffsetPageResponseMyChallengeVoucherDto;

export const fetchClientApiV1UserStatistics = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1UserStatisticsResponse>(url, requestOptions);

export interface ClientApiV1UserStatisticsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1UserStatisticsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1UserStatisticsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1UserStatisticsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1UserStatistics(url, requestOptions),
  ...options,
});

export function useClientApiV1UserStatisticsQuery(params: ClientApiV1UserStatisticsQueryParams) {
  const result = useQuery<ClientApiV1UserStatisticsResponse, unknown>(
    getClientApiV1UserStatisticsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 사용자 통계 정보 */
export type ClientApiV1UserStatisticsQueryString = Partial<{
  withCache: boolean;
}>;

export type ClientApiV1UserStatisticsResponse = ApiResponseUserStatisticsResponse;

export const fetchClientApiV1RouletteResults = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1RouletteResultsResponse>(url, requestOptions);

export interface ClientApiV1RouletteResultsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1RouletteResultsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1RouletteResultsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1RouletteResultsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1RouletteResults(url, requestOptions),
  ...options,
});

export function useClientApiV1RouletteResultsQuery(params: ClientApiV1RouletteResultsQueryParams) {
  const result = useQuery<ClientApiV1RouletteResultsResponse, unknown>(
    getClientApiV1RouletteResultsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1RouletteResultsResponse = ApiResponseRouletteResultsResponse;

export const fetchClientApiV1RoadmapAuthorUserId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1RoadmapAuthorUserIdResponse>(url, requestOptions);

export interface ClientApiV1RoadmapAuthorUserIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1RoadmapAuthorUserIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1RoadmapAuthorUserIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1RoadmapAuthorUserIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1RoadmapAuthorUserId(url, requestOptions),
  ...options,
});

export function useClientApiV1RoadmapAuthorUserIdQuery(
  params: ClientApiV1RoadmapAuthorUserIdQueryParams,
) {
  const result = useQuery<ClientApiV1RoadmapAuthorUserIdResponse, unknown>(
    getClientApiV1RoadmapAuthorUserIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 주어진 유저가 생성한 로드맵을 조회한다 */
export type ClientApiV1RoadmapAuthorUserIdQueryString = Partial<{
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1RoadmapAuthorUserIdResponse = ApiResponseRoadmapsByAuthorResponse;

export const fetchClientApiV1OrderSummaries = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1OrderSummariesResponse>(url, requestOptions);

export interface ClientApiV1OrderSummariesQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1OrderSummariesResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1OrderSummariesQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1OrderSummariesQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1OrderSummaries(url, requestOptions),
  ...options,
});

export function useClientApiV1OrderSummariesQuery(params: ClientApiV1OrderSummariesQueryParams) {
  const result = useQuery<ClientApiV1OrderSummariesResponse, unknown>(
    getClientApiV1OrderSummariesQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1OrderSummariesResponse = ApiResponseFindOrderSummaryResponse;

export function useClientApiV1MyListsIdDeleteMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1MyListsIdDeleteResponse,
    unknown,
    ClientApiV1MyListsIdDeleteVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1MyListsIdDeleteResponse,
    unknown,
    ClientApiV1MyListsIdDeleteVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1MyListsIdDeleteVariables) =>
      fetcher.delete(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1MyListsIdDeleteResponse = EmptyOkResponse;

export type ClientApiV1MyListsIdDeleteVariables = unknown;

export const fetchClientApiV1MarketingPartnersCoursesSearch = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1MarketingPartnersCoursesSearchResponse>(url, requestOptions);

export interface ClientApiV1MarketingPartnersCoursesSearchQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1MarketingPartnersCoursesSearchResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1MarketingPartnersCoursesSearchQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1MarketingPartnersCoursesSearchQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1MarketingPartnersCoursesSearch(url, requestOptions),
  ...options,
});

export function useClientApiV1MarketingPartnersCoursesSearchQuery(
  params: ClientApiV1MarketingPartnersCoursesSearchQueryParams,
) {
  const result = useQuery<ClientApiV1MarketingPartnersCoursesSearchResponse, unknown>(
    getClientApiV1MarketingPartnersCoursesSearchQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 파트너스 강의 검색 */
export type ClientApiV1MarketingPartnersCoursesSearchQueryString = Partial<{
  userId: number;
  category: string;
  keyword: string;
  sort: 'POPULAR' | 'RECENT' | 'PRICE' | 'REVENUE' | 'MARGIN' | 'REVIEW' | 'STUDENT' | 'RATING';
  pageNumber: number;
  pageSize: number;
  lang: string;
}>;

export type ClientApiV1MarketingPartnersCoursesSearchResponse =
  ApiResponseSearchPartnerCourseResponse;

export const fetchClientApiV1MarketingPartnerLinksCreatePreview = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1MarketingPartnerLinksCreatePreviewResponse>(url, requestOptions);

export interface ClientApiV1MarketingPartnerLinksCreatePreviewQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1MarketingPartnerLinksCreatePreviewResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1MarketingPartnerLinksCreatePreviewQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1MarketingPartnerLinksCreatePreviewQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1MarketingPartnerLinksCreatePreview(url, requestOptions),
  ...options,
});

export function useClientApiV1MarketingPartnerLinksCreatePreviewQuery(
  params: ClientApiV1MarketingPartnerLinksCreatePreviewQueryParams,
) {
  const result = useQuery<ClientApiV1MarketingPartnerLinksCreatePreviewResponse, unknown>(
    getClientApiV1MarketingPartnerLinksCreatePreviewQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 마케팅 파트너 홍보링크 생성 미리보기를 조회한다 */
export type ClientApiV1MarketingPartnerLinksCreatePreviewQueryString = Partial<{
  courseId: number;
  isAdpickMarketer: boolean;
}>;

export type ClientApiV1MarketingPartnerLinksCreatePreviewResponse =
  ApiResponseGetMarketingPartnerLinkCreatePreviewResponse;

export const fetchClientApiV1ExpertProposalsMe = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProposalsMeResponse>(url, requestOptions);

export interface ClientApiV1ExpertProposalsMeQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProposalsMeResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProposalsMeQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProposalsMeQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProposalsMe(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProposalsMeQuery(
  params: ClientApiV1ExpertProposalsMeQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProposalsMeResponse, unknown>(
    getClientApiV1ExpertProposalsMeQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 내가 보낸 AX 제안서 목록 조회 (승인된 전문가만) */
export type ClientApiV1ExpertProposalsMeQueryString = Partial<{
  status: 'REVIEWING' | 'SELECTED' | 'NOT_SELECTED' | 'WITHDRAWN';
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertProposalsMeResponse =
  ApiResponseSearchMyExpertProjectProposalsResponse;

export const fetchClientApiV1ExpertProjectsProjectId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProjectsProjectIdResponse>(url, requestOptions);

export interface ClientApiV1ExpertProjectsProjectIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProjectsProjectIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProjectsProjectIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProjectsProjectIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProjectsProjectId(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProjectsProjectIdQuery(
  params: ClientApiV1ExpertProjectsProjectIdQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProjectsProjectIdResponse, unknown>(
    getClientApiV1ExpertProjectsProjectIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsProjectIdResponse = ApiResponseGetOpenExpertProjectResponse;

export const fetchClientApiV1ExpertProjectsMe = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProjectsMeResponse>(url, requestOptions);

export interface ClientApiV1ExpertProjectsMeQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProjectsMeResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProjectsMeQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProjectsMeQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProjectsMe(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProjectsMeQuery(
  params: ClientApiV1ExpertProjectsMeQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProjectsMeResponse, unknown>(
    getClientApiV1ExpertProjectsMeQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 내가 접수한 AX 의뢰 목록 조회 */
export type ClientApiV1ExpertProjectsMeQueryString = Partial<{
  status: 'RECEIVED' | 'MATCHING' | 'PROPOSED' | 'MATCHED' | 'COMPLETED' | 'CLOSED' | 'CANCELLED';
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertProjectsMeResponse = ApiResponseSearchMyExpertProjectsResponse;

export const fetchClientApiV1ExpertProjectsMeProjectId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProjectsMeProjectIdResponse>(url, requestOptions);

export interface ClientApiV1ExpertProjectsMeProjectIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProjectsMeProjectIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProjectsMeProjectIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProjectsMeProjectIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProjectsMeProjectId(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProjectsMeProjectIdQuery(
  params: ClientApiV1ExpertProjectsMeProjectIdQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProjectsMeProjectIdResponse, unknown>(
    getClientApiV1ExpertProjectsMeProjectIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsMeProjectIdResponse = ApiResponseGetMyExpertProjectResponse;

export const fetchClientApiV1ExpertProjectsMeProjectIdProposals = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertProjectsMeProjectIdProposalsResponse>(url, requestOptions);

export interface ClientApiV1ExpertProjectsMeProjectIdProposalsQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProjectsMeProjectIdProposalsResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProjectsMeProjectIdProposalsQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProjectsMeProjectIdProposalsQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProjectsMeProjectIdProposals(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProjectsMeProjectIdProposalsQuery(
  params: ClientApiV1ExpertProjectsMeProjectIdProposalsQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProjectsMeProjectIdProposalsResponse, unknown>(
    getClientApiV1ExpertProjectsMeProjectIdProposalsQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsMeProjectIdProposalsResponse =
  ApiResponseListReceivedExpertProjectProposalResponse;

export const fetchClientApiV1ExpertProjectsMeProjectIdProposalsProposalId = async (
  url: string,
  requestOptions?: RequestOptions,
) =>
  fetcher.get<ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdResponse>(url, requestOptions);

export interface ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertProjectsMeProjectIdProposalsProposalId(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdQuery(
  params: ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdResponse, unknown>(
    getClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertProjectsMeProjectIdProposalsProposalIdResponse =
  ApiResponseGetReceivedExpertProjectProposalResponse;

export const fetchClientApiV1ExpertOfferingsMe = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertOfferingsMeResponse>(url, requestOptions);

export interface ClientApiV1ExpertOfferingsMeQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertOfferingsMeResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertOfferingsMeQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertOfferingsMeQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertOfferingsMe(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertOfferingsMeQuery(
  params: ClientApiV1ExpertOfferingsMeQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertOfferingsMeResponse, unknown>(
    getClientApiV1ExpertOfferingsMeQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 내 AX 서비스 목록 조회 (삭제 제외, 최근 수정순). 전문가 프로필이 없으면 FORBIDDEN */
export type ClientApiV1ExpertOfferingsMeQueryString = Partial<{
  status: 'DRAFT' | 'PUBLISH' | 'PAUSE';
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertOfferingsMeResponse = ApiResponseSearchMyExpertOfferingsResponse;

export const fetchClientApiV1ExpertOfferingVouchersReceived = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertOfferingVouchersReceivedResponse>(url, requestOptions);

export interface ClientApiV1ExpertOfferingVouchersReceivedQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertOfferingVouchersReceivedResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertOfferingVouchersReceivedQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertOfferingVouchersReceivedQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertOfferingVouchersReceived(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertOfferingVouchersReceivedQuery(
  params: ClientApiV1ExpertOfferingVouchersReceivedQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertOfferingVouchersReceivedResponse, unknown>(
    getClientApiV1ExpertOfferingVouchersReceivedQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 내 서비스에 발급된 이용권 목록 조회 (최근 결제순). status=IN_PROGRESS 는 PAID 를 함께 돌려준다. 구매자 연락처는 내려가지 않는다 */
export type ClientApiV1ExpertOfferingVouchersReceivedQueryString = Partial<{
  status: 'PAID' | 'IN_PROGRESS' | 'ENDED' | 'CANCELED';
  offeringId: string;
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1ExpertOfferingVouchersReceivedResponse =
  ApiResponseSearchReceivedExpertOfferingVouchersResponse;

export const fetchClientApiV1ExpertOfferingOrdersOrderId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ExpertOfferingOrdersOrderIdResponse>(url, requestOptions);

export interface ClientApiV1ExpertOfferingOrdersOrderIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ExpertOfferingOrdersOrderIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1ExpertOfferingOrdersOrderIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1ExpertOfferingOrdersOrderIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1ExpertOfferingOrdersOrderId(url, requestOptions),
  ...options,
});

export function useClientApiV1ExpertOfferingOrdersOrderIdQuery(
  params: ClientApiV1ExpertOfferingOrdersOrderIdQueryParams,
) {
  const result = useQuery<ClientApiV1ExpertOfferingOrdersOrderIdResponse, unknown>(
    getClientApiV1ExpertOfferingOrdersOrderIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingOrdersOrderIdResponse =
  ApiResponseGetExpertOfferingOrderResponse;

export const fetchClientApiV1CoursesIdSimple = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CoursesIdSimpleResponse>(url, requestOptions);

export interface ClientApiV1CoursesIdSimpleQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CoursesIdSimpleResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CoursesIdSimpleQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CoursesIdSimpleQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CoursesIdSimple(url, requestOptions),
  ...options,
});

export function useClientApiV1CoursesIdSimpleQuery(params: ClientApiV1CoursesIdSimpleQueryParams) {
  const result = useQuery<ClientApiV1CoursesIdSimpleResponse, unknown>(
    getClientApiV1CoursesIdSimpleQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CoursesIdSimpleResponse = ApiResponseCourseSimpleOneResponse;

export const fetchClientApiV1CoursesCourseIdPaymentInfo = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CoursesCourseIdPaymentInfoResponse>(url, requestOptions);

export interface ClientApiV1CoursesCourseIdPaymentInfoQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CoursesCourseIdPaymentInfoResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CoursesCourseIdPaymentInfoQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CoursesCourseIdPaymentInfoQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CoursesCourseIdPaymentInfo(url, requestOptions),
  ...options,
});

export function useClientApiV1CoursesCourseIdPaymentInfoQuery(
  params: ClientApiV1CoursesCourseIdPaymentInfoQueryParams,
) {
  const result = useQuery<ClientApiV1CoursesCourseIdPaymentInfoResponse, unknown>(
    getClientApiV1CoursesCourseIdPaymentInfoQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** Course ID 기반으로 강의 결제 정보(평점, 카테고리, 가격 등)를 조회한다. */
export type ClientApiV1CoursesCourseIdPaymentInfoQueryString = Partial<{
  lang: string;
}>;

export type ClientApiV1CoursesCourseIdPaymentInfoResponse = ApiResponseGetCourseDetailInfoResponse;

export const fetchClientApiV1CoursesTop = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV1CoursesTopResponse>(url, requestOptions);

export interface ClientApiV1CoursesTopQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CoursesTopResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CoursesTopQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CoursesTopQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CoursesTop(url, requestOptions),
  ...options,
});

export function useClientApiV1CoursesTopQuery(params: ClientApiV1CoursesTopQueryParams) {
  const result = useQuery<ClientApiV1CoursesTopResponse, unknown>(
    getClientApiV1CoursesTopQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 카테고리별 온라인 인기 강의 Top N을 조회한다. 대상 강의 선정은 비개인화(PG 인기순), 카드는 로그인 유저 기준 개인화. */
export type ClientApiV1CoursesTopQueryString = Partial<{
  categorySlug: string;
  limit: number;
  lang: string;
}>;

export type ClientApiV1CoursesTopResponse = ApiResponseSearchCourseResponse;

export const fetchClientApiV1CoursesSubscription = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CoursesSubscriptionResponse>(url, requestOptions);

export interface ClientApiV1CoursesSubscriptionQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CoursesSubscriptionResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CoursesSubscriptionQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CoursesSubscriptionQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CoursesSubscription(url, requestOptions),
  ...options,
});

export function useClientApiV1CoursesSubscriptionQuery(
  params: ClientApiV1CoursesSubscriptionQueryParams,
) {
  const result = useQuery<ClientApiV1CoursesSubscriptionResponse, unknown>(
    getClientApiV1CoursesSubscriptionQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 구독으로 볼 수 있는 강의 목록을 조회한다. 그룹 노출 제한 없이 모든 방문자에게 동일한 목록을 반환한다. */
export type ClientApiV1CoursesSubscriptionQueryString = Partial<{
  keyword: string;
  categories: string;
  sort: string;
  pageNumber: number;
  pageSize: number;
  lang: string;
}>;

export type ClientApiV1CoursesSubscriptionResponse = ApiResponseGetSubscriptionCoursesResponse;

export const fetchClientApiV1CourseUserUserId = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseUserUserIdResponse>(url, requestOptions);

export interface ClientApiV1CourseUserUserIdQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseUserUserIdResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseUserUserIdQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseUserUserIdQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseUserUserId(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseUserUserIdQuery(
  params: ClientApiV1CourseUserUserIdQueryParams,
) {
  const result = useQuery<ClientApiV1CourseUserUserIdResponse, unknown>(
    getClientApiV1CourseUserUserIdQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 유저 프로필 강의리스트 조회 */
export type ClientApiV1CourseUserUserIdQueryString = Partial<{
  sort: 'RECENT' | 'POPULAR' | 'RECOMMEND';
  pageNumber: number;
  pageSize: number;
  lang: string;
}>;

export type ClientApiV1CourseUserUserIdResponse = ApiResponseUserProfileCourseResponse;

export const fetchClientApiV1CourseLikes = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV1CourseLikesResponse>(url, requestOptions);

export interface ClientApiV1CourseLikesQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CourseLikesResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseLikesQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseLikesQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseLikes(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseLikesQuery(params: ClientApiV1CourseLikesQueryParams) {
  const result = useQuery<ClientApiV1CourseLikesResponse, unknown>(
    getClientApiV1CourseLikesQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 좋아요한 강의 카드 리스트 조회 */
export type ClientApiV1CourseLikesQueryString = Partial<{
  sort: 'RECENT' | 'TITLE' | 'STUDENT' | 'RATING';
  chargeType: 'FREE' | 'PAID' | 'ALL';
  lang: string;
}>;

export type ClientApiV1CourseLikesResponse = ApiResponseCourseByLikesResponse;

export const fetchClientApiV1CourseGiftsSent = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseGiftsSentResponse>(url, requestOptions);

export interface ClientApiV1CourseGiftsSentQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseGiftsSentResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseGiftsSentQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseGiftsSentQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseGiftsSent(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseGiftsSentQuery(params: ClientApiV1CourseGiftsSentQueryParams) {
  const result = useQuery<ClientApiV1CourseGiftsSentResponse, unknown>(
    getClientApiV1CourseGiftsSentQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 보낸 강의 선물 내역 리스트를 조회한다 */
export type ClientApiV1CourseGiftsSentQueryString = Partial<{
  userId: number;
  userAgent: UserAgent;
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1CourseGiftsSentResponse = ApiResponseFindSentCourseGiftResponse;

export const fetchClientApiV1CourseGiftsReceived = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseGiftsReceivedResponse>(url, requestOptions);

export interface ClientApiV1CourseGiftsReceivedQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseGiftsReceivedResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseGiftsReceivedQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseGiftsReceivedQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseGiftsReceived(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseGiftsReceivedQuery(
  params: ClientApiV1CourseGiftsReceivedQueryParams,
) {
  const result = useQuery<ClientApiV1CourseGiftsReceivedResponse, unknown>(
    getClientApiV1CourseGiftsReceivedQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 받은 선물 내역 리스트를 조회한다 */
export type ClientApiV1CourseGiftsReceivedQueryString = Partial<{
  userId: number;
  pageNumber: number;
  pageSize: number;
}>;

export type ClientApiV1CourseGiftsReceivedResponse = ApiResponseFindReceivedCourseGiftResponse;

export const fetchClientApiV1CourseCertificates = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseCertificatesResponse>(url, requestOptions);

export interface ClientApiV1CourseCertificatesQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseCertificatesResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseCertificatesQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseCertificatesQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseCertificates(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseCertificatesQuery(
  params: ClientApiV1CourseCertificatesQueryParams,
) {
  const result = useQuery<ClientApiV1CourseCertificatesResponse, unknown>(
    getClientApiV1CourseCertificatesQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 사용자의 수료증 목록을 조회한다 */
export type ClientApiV1CourseCertificatesQueryString = Partial<{
  userId: number;
  isArchived: boolean;
  sort: 'CERTIFICATED' | 'CONFIRMED';
  lang: string;
}>;

export type ClientApiV1CourseCertificatesResponse = ApiResponseListGetCertificatesResponse;

export const fetchClientApiV1CourseCertificatesUnconfirmed = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseCertificatesUnconfirmedResponse>(url, requestOptions);

export interface ClientApiV1CourseCertificatesUnconfirmedQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseCertificatesUnconfirmedResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseCertificatesUnconfirmedQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseCertificatesUnconfirmedQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseCertificatesUnconfirmed(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseCertificatesUnconfirmedQuery(
  params: ClientApiV1CourseCertificatesUnconfirmedQueryParams,
) {
  const result = useQuery<ClientApiV1CourseCertificatesUnconfirmedResponse, unknown>(
    getClientApiV1CourseCertificatesUnconfirmedQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseCertificatesUnconfirmedResponse = ApiResponseUnconfirmedResponse;

export const fetchClientApiV1CourseCertificatesDetail = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseCertificatesDetailResponse>(url, requestOptions);

export interface ClientApiV1CourseCertificatesDetailQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseCertificatesDetailResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseCertificatesDetailQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseCertificatesDetailQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseCertificatesDetail(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseCertificatesDetailQuery(
  params: ClientApiV1CourseCertificatesDetailQueryParams,
) {
  const result = useQuery<ClientApiV1CourseCertificatesDetailResponse, unknown>(
    getClientApiV1CourseCertificatesDetailQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 수료증 상세 정보를 조회한다 */
export type ClientApiV1CourseCertificatesDetailQueryString = Partial<{
  userId: number;
  voucherId: number;
  courseId: number;
  lang: string;
}>;

export type ClientApiV1CourseCertificatesDetailResponse = ApiResponseGetCertificateDetailResponse;

export const fetchClientApiV1CourseCertificatesChallengeDetail = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1CourseCertificatesChallengeDetailResponse>(url, requestOptions);

export interface ClientApiV1CourseCertificatesChallengeDetailQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1CourseCertificatesChallengeDetailResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CourseCertificatesChallengeDetailQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CourseCertificatesChallengeDetailQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CourseCertificatesChallengeDetail(url, requestOptions),
  ...options,
});

export function useClientApiV1CourseCertificatesChallengeDetailQuery(
  params: ClientApiV1CourseCertificatesChallengeDetailQueryParams,
) {
  const result = useQuery<ClientApiV1CourseCertificatesChallengeDetailResponse, unknown>(
    getClientApiV1CourseCertificatesChallengeDetailQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 챌린지 수료증 상세 정보를 조회한다 */
export type ClientApiV1CourseCertificatesChallengeDetailQueryString = Partial<{
  userId: number;
  voucherId: number;
  courseId: number;
  lang: string;
}>;

export type ClientApiV1CourseCertificatesChallengeDetailResponse =
  ApiResponseGetCertificateDetailResponse;

export const fetchClientApiV1CategoryMain = async (url: string, requestOptions?: RequestOptions) =>
  fetcher.get<ClientApiV1CategoryMainResponse>(url, requestOptions);

export interface ClientApiV1CategoryMainQueryParams {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CategoryMainResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}

export const getClientApiV1CategoryMainQueryOptions = ({
  queryKey,
  url,
  options,
  requestOptions,
}: ClientApiV1CategoryMainQueryParams) => ({
  queryKey: queryKey,
  queryFn: () => fetchClientApiV1CategoryMain(url, requestOptions),
  ...options,
});

export function useClientApiV1CategoryMainQuery(params: ClientApiV1CategoryMainQueryParams) {
  const result = useQuery<ClientApiV1CategoryMainResponse, unknown>(
    getClientApiV1CategoryMainQueryOptions(params),
  );

  return { ...result, data: result.data?.data };
}

/** 부모 카테고리를 조회한다 */
export type ClientApiV1CategoryMainQueryString = Partial<{
  lang: string;
}>;

export type ClientApiV1CategoryMainResponse = ApiResponseFindParentCategoryResponse;

export function useClientApiV1VouchersIdFreeDeleteMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1VouchersIdFreeDeleteResponse,
    unknown,
    ClientApiV1VouchersIdFreeDeleteVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1VouchersIdFreeDeleteResponse,
    unknown,
    ClientApiV1VouchersIdFreeDeleteVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1VouchersIdFreeDeleteVariables) =>
      fetcher.delete(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1VouchersIdFreeDeleteResponse = EmptyOkResponse;

export type ClientApiV1VouchersIdFreeDeleteVariables = unknown;

export function useClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteResponse,
    unknown,
    ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteResponse,
    unknown,
    ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteVariables,
    TContext
  >({
    mutationFn: (variables: ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteVariables) =>
      fetcher.delete(url, variables, requestOptions),
    ...options,
  });

  return { ...result, data: result.data?.data };
}

export type ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteResponse = EmptyOkResponse;

export type ClientApiV1ExpertOfferingsMeExpertOfferingIdDeleteVariables = unknown;

export interface EmptyOkResponse {
  message: string;
  data?: string | null;
  statusCode: string;
  errorCode?: string | null;
}

export interface ConfirmEnrollmentVerificationRequest {
  voucherId: number;
}

export interface ArchiveVoucherV2Request {
  id: number;
  isArchive: boolean;
}

export interface UpdateMyListRequest {
  id: number;
  title: string;
}

export interface SubmitExpertProjectProposalRequest {
  /**
   * 제안 금액(원, 부가세 가산 전 총액). 1,000원 이상
   */
  price: number;
  message: string;
  /**
   * 작업 기간(일)
   */
  workDays?: number | null;
}

export interface UpdateExpertProfileRequest {
  activityType: 'INDIVIDUAL' | 'TEAM';
  name: string;
  companyName?: string | null;
  isCompanyExposed: boolean;
  teamSize?: number | null;
  headline: string;
  skillTags: string[];
  careerYears?: number | null;
  portfolioUrl?: string | null;
  availableFrom?: 'IMMEDIATELY' | 'WITHIN_ONE_MONTH' | 'WITHIN_THREE_MONTHS' | 'NOT_DECIDED';
  weeklyHours?: number | null;
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  isPriceNegotiable: boolean;
  priceUnit?: 'HOUR' | 'DAY' | 'PROJECT';
  priceMin?: number | null;
  priceMax?: number | null;
  contactEmail: string;
  contactPhone: string;
}

export interface Unit {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: null;
}

export interface ExpertOfferingDeliverableRequest {
  title: string;
  /**
   * 결과물 이미지 fileId. 선택 입력
   */
  fileId?: number | null;
}

export interface ExpertOfferingFaqRequest {
  question: string;
  answer: string;
}

export interface ExpertOfferingStepRequest {
  label: string;
  content: string;
  duration?: string | null;
  /**
   * 단계 이미지 fileId. 선택 입력
   */
  fileId?: number | null;
}

export interface UpdateExpertOfferingRequest {
  title: string;
  /**
   * 상세 사진 fileId(업로드 URL 발급 API 응답). 순서대로 노출하고 첫 번째 사진이 대표 이미지가 된다. 최대 10장, 중복 불가
   */
  imageFileIds: number[];
  description: string;
  /**
   * 분야. 최대 3개, 중복 불가
   */
  categories: (
    | 'AUTOMATION'
    | 'CONTENT'
    | 'DATA'
    | 'CHATBOT'
    | 'RAG'
    | 'CONSULTING'
    | 'EDUCATION'
    | 'INTEGRATION'
    | 'MARKETING'
    | 'SALES'
    | 'HR'
    | 'FINANCE'
    | 'LEGAL'
    | 'RESEARCH'
    | 'VOICE'
    | 'VISION'
    | 'TRANSLATION'
    | 'SECURITY'
    | 'PROTOTYPE'
    | 'OTHER'
  )[];
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  estimatedPeriod?:
    | 'WEEK_1'
    | 'WEEK_2'
    | 'WEEK_3'
    | 'MONTH_1'
    | 'MONTH_2'
    | 'MONTH_3'
    | 'MONTH_6'
    | 'MONTH_6_PLUS';
  clientEffort?: 'NONE' | 'WEEKLY_1_2H' | 'WEEKLY_HALF_DAY' | 'WEEKLY_1_DAY_PLUS';
  steps: ExpertOfferingStepRequest[];
  deliverables: ExpertOfferingDeliverableRequest[];
  /**
   * 이 금액에 포함된 항목. 최대 10개, 항목마다 60자 이하, 빈 항목은 저장하지 않는다
   */
  inclusions: string[];
  /**
   * 따로 드는 비용 항목. 최대 10개, 항목마다 60자 이하, 빈 항목은 저장하지 않는다
   */
  exclusions: string[];
  faqs: ExpertOfferingFaqRequest[];
  /**
   * 가격(부가세 별도). 1,000원 이상. 작성 중(DRAFT)에는 비워도 되고 공개(PUBLISH)할 때는 필수
   */
  price?: number | null;
  status: 'DRAFT' | 'PUBLISH' | 'PAUSE';
}

export interface ExpertSummaryResponse {
  id: number;
  activityType: 'INDIVIDUAL' | 'TEAM';
  name: string;
  companyName?: string | null;
  headline: string;
  skills: ExpertSummaryResponseSkillTagResponse[];
  careerYears?: number | null;
  teamSize?: number | null;
}

export interface ExpertSummaryResponseSkillTagResponse {
  id: number;
  name: string;
}

export interface GetExpertOfferingResponse {
  id: number;
  title: string;
  thumbnailUrl?: string | null;
  images: GetExpertOfferingResponseImageResponse[];
  description: string;
  categories: (
    | 'AUTOMATION'
    | 'CONTENT'
    | 'DATA'
    | 'CHATBOT'
    | 'RAG'
    | 'CONSULTING'
    | 'EDUCATION'
    | 'INTEGRATION'
    | 'MARKETING'
    | 'SALES'
    | 'HR'
    | 'FINANCE'
    | 'LEGAL'
    | 'RESEARCH'
    | 'VOICE'
    | 'VISION'
    | 'TRANSLATION'
    | 'SECURITY'
    | 'PROTOTYPE'
    | 'OTHER'
  )[];
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  estimatedPeriod?:
    | 'WEEK_1'
    | 'WEEK_2'
    | 'WEEK_3'
    | 'MONTH_1'
    | 'MONTH_2'
    | 'MONTH_3'
    | 'MONTH_6'
    | 'MONTH_6_PLUS';
  clientEffort?: 'NONE' | 'WEEKLY_1_2H' | 'WEEKLY_HALF_DAY' | 'WEEKLY_1_DAY_PLUS';
  steps: StepResponse[];
  deliverables: DeliverableResponse[];
  inclusions: string[];
  exclusions: string[];
  faqs: GetExpertOfferingResponseFaqResponse[];
  price?: number | null;
  regularPrice?: number | null;
  status: 'DRAFT' | 'PUBLISH' | 'PAUSE';
  expert: ExpertSummaryResponse;
  reviewSummary: ReviewSummaryResponse;
  bookmarkCount: number;
  isBookmarked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface DeliverableResponse {
  title: string;
  fileId?: number | null;
  imageUrl?: string | null;
}

export interface GetExpertOfferingResponseFaqResponse {
  question: string;
  answer: string;
}

export interface GetExpertOfferingResponseImageResponse {
  fileId: number;
  url: string;
}

export interface ReviewSummaryResponse {
  averageRating?: number | null;
  count: number;
}

export interface StepResponse {
  label: string;
  content: string;
  duration?: string | null;
  fileId?: number | null;
  imageUrl?: string | null;
}

export interface ApiResponseGetExpertOfferingResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetExpertOfferingResponse;
}

export interface ExpertOfferingReviewResponse {
  id: number;
  rating: number;
  content: string;
  images: ExpertOfferingReviewResponseImageResponse[];
  writer: WriterResponse;
  isMine: boolean;
  createdAt: string;
}

export interface ExpertOfferingReviewResponseImageResponse {
  fileId: number;
  url: string;
}

export interface WriterResponse {
  name?: string | null;
}

export interface UpdateExpertOfferingBookmarkRequest {
  /**
   * true 면 북마크, false 면 북마크 해제
   */
  isBookmarked: boolean;
}

export interface CancelExpertOfferingVoucherRequest {
  reasonType: 'PAYMENT_METHOD_CHANGE' | 'DISCOUNT' | 'CHANGE_MIND' | 'DISSATISFACTION' | 'ETC';
  reasonMessage?: string | null;
}

export interface ConfirmCourseCertificateRequestV2 {
  voucherId: number;
}

export interface ConfirmCourseCertificateResponse {
  now: string;
  nowUTC: string;
}

export interface ApiResponseConfirmCourseCertificateResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: ConfirmCourseCertificateResponse;
}

export interface CommissionRate {
  agreed: number;
  disagreed: number;
}

export interface CreateOrderBuyerDto {
  name: string;
  email: string;
  phoneNumber: string;
  countryCode: string;
}

export interface RouletteDrawResponse {
  resultType: 'PRIZE' | 'POINT';
  /**
   * 당첨 경품명. resultType=PRIZE 일 때만 존재하고, POINT 면 null
   */
  prizeName?: string | null;
  /**
   * 지급된 포인트. resultType=POINT 일 때만 존재하고, PRIZE 면 null
   */
  point?: number | null;
}

export interface ApiResponseRouletteDrawResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: RouletteDrawResponse;
}

export interface UpdateMyListsSequenceRequest {
  ids: number[];
}

export interface UpdateMyListCourseSequenceRequest {
  listId: number;
  courseIds: number[];
}

export interface AddCourseRequest {
  listId: number;
  courseId: number;
}

export interface CreateMyListRequest {
  title: string;
}

export interface SignupMarketingPartnerRequest {
  name: string;
  email: string;
  phone: string;
  countryCode: string;
  type: 'BUSINESS' | 'PERSONAL';
  activityLink?: string | null;
}

export interface SignupMarketingPartnerResponse {
  id: number;
  commissionRate: CommissionRate;
}

export interface ApiResponseSignupMarketingPartnerResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SignupMarketingPartnerResponse;
}

export interface CreateMarketingPartnerLinkRequest {
  courseId: number;
}

export interface CreateMarketingPartnerLinkResponse {
  link: string;
}

export interface ApiResponseCreateMarketingPartnerLinkResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: CreateMarketingPartnerLinkResponse;
}

export interface SubmitExpertProjectRequest {
  /**
   * 의뢰 제목. 앞뒤 공백 제거 후 2~100자
   */
  title: string;
  companyName: string;
  companySize:
    | 'ONE_FOUR'
    | 'FIVE_TEN'
    | 'ELEVEN_FIFTY'
    | 'FIFTY_ONE_TWO_HUNDRED'
    | 'TWO_HUNDRED_FIVE_HUNDRED'
    | 'FIVE_HUNDRED_THOUSAND'
    | 'THOUSAND_FIVE_THOUSAND'
    | 'TEN_THOUSAND'
    | 'TEN_THOUSAND_UPPER';
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  /**
   * 완료 희망일(yyyy-MM-dd). 내일 이후 날짜만
   */
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  workMode: 'REMOTE' | 'ONSITE' | 'NEGOTIABLE';
  /**
   * 진행 지역. 시·도 17개 중 하나(서울·부산·대구·인천·광주·대전·울산·세종·경기·강원·충북·충남·전북·전남·경북·경남·제주). 현장(ONSITE)이면 필수, 협의면 선택, 원격이면 무시하고 null 로 저장한다
   */
  workRegion?: string | null;
  /**
   * 교육 대상 인원(1~10000). 교육이 포함된 패키지(FULL·EDUCATION)에서만 받고 그 외는 null 로 저장한다
   */
  headcount?: number | null;
  message: string;
  contactName: string;
  department?: string | null;
  position?: string | null;
  contactEmail: string;
  contactPhone: string;
  isPrivacyAgreed: boolean;
  isMarketingAgreed: boolean;
}

export interface SubmitExpertProjectResponse {
  id: number;
}

export interface ApiResponseSubmitExpertProjectResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SubmitExpertProjectResponse;
}

export interface SubmitExpertProjectProposalResponse {
  proposalId: number;
}

export interface ApiResponseSubmitExpertProjectProposalResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SubmitExpertProjectProposalResponse;
}

export interface AcceptExpertProjectProposalRequest {
  /**
   * 기업이 본 제안서 revision. 현재 revision 과 다르면 409(errorCode=PROPOSAL_REVISION_MISMATCH)
   */
  revision: number;
}

export interface ApplyExpertProfileRequest {
  activityType: 'INDIVIDUAL' | 'TEAM';
  name: string;
  companyName?: string | null;
  isCompanyExposed: boolean;
  teamSize?: number | null;
  headline: string;
  skillTags: string[];
  careerYears?: number | null;
  portfolioUrl?: string | null;
  availableFrom?: 'IMMEDIATELY' | 'WITHIN_ONE_MONTH' | 'WITHIN_THREE_MONTHS' | 'NOT_DECIDED';
  weeklyHours?: number | null;
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  isPriceNegotiable: boolean;
  priceUnit?: 'HOUR' | 'DAY' | 'PROJECT';
  priceMin?: number | null;
  priceMax?: number | null;
  contactEmail: string;
  contactPhone: string;
  isPrivacyAgreed: boolean;
}

export interface ApplyExpertProfileResponse {
  id: number;
}

export interface ApiResponseApplyExpertProfileResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: ApplyExpertProfileResponse;
}

export interface CreateExpertOfferingRequest {
  title: string;
  /**
   * 상세 사진 fileId(업로드 URL 발급 API 응답). 순서대로 노출하고 첫 번째 사진이 대표 이미지가 된다. 최대 10장, 중복 불가
   */
  imageFileIds: number[];
  description: string;
  /**
   * 분야. 최대 3개, 중복 불가
   */
  categories: (
    | 'AUTOMATION'
    | 'CONTENT'
    | 'DATA'
    | 'CHATBOT'
    | 'RAG'
    | 'CONSULTING'
    | 'EDUCATION'
    | 'INTEGRATION'
    | 'MARKETING'
    | 'SALES'
    | 'HR'
    | 'FINANCE'
    | 'LEGAL'
    | 'RESEARCH'
    | 'VOICE'
    | 'VISION'
    | 'TRANSLATION'
    | 'SECURITY'
    | 'PROTOTYPE'
    | 'OTHER'
  )[];
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  estimatedPeriod?:
    | 'WEEK_1'
    | 'WEEK_2'
    | 'WEEK_3'
    | 'MONTH_1'
    | 'MONTH_2'
    | 'MONTH_3'
    | 'MONTH_6'
    | 'MONTH_6_PLUS';
  clientEffort?: 'NONE' | 'WEEKLY_1_2H' | 'WEEKLY_HALF_DAY' | 'WEEKLY_1_DAY_PLUS';
  steps: ExpertOfferingStepRequest[];
  deliverables: ExpertOfferingDeliverableRequest[];
  /**
   * 이 금액에 포함된 항목. 최대 10개, 항목마다 60자 이하, 빈 항목은 저장하지 않는다
   */
  inclusions: string[];
  /**
   * 따로 드는 비용 항목. 최대 10개, 항목마다 60자 이하, 빈 항목은 저장하지 않는다
   */
  exclusions: string[];
  faqs: ExpertOfferingFaqRequest[];
  /**
   * 가격(부가세 별도). 1,000원 이상. 작성 중(DRAFT)에는 비워도 되고 공개(PUBLISH)할 때는 필수
   */
  price?: number | null;
  status: 'DRAFT' | 'PUBLISH' | 'PAUSE';
}

export interface CreateExpertOfferingImageUploadUrlsRequest {
  images: CreateExpertOfferingImageUploadUrlsRequestImage[];
}

export interface CreateExpertOfferingImageUploadUrlsRequestImage {
  name: string;
  type: string;
  size: number;
}

export interface CreateExpertOfferingImageUploadUrlsResponse {
  images: CreateExpertOfferingImageUploadUrlsResponseImageUploadUrl[];
}

export interface CreateExpertOfferingImageUploadUrlsResponseImageFileMetadata {
  name: string;
  type: string;
  updatedAtUTC: string;
}

export interface CreateExpertOfferingImageUploadUrlsResponseImageUploadUrl {
  uploadUrl: string;
  fileId: number;
  metadata: CreateExpertOfferingImageUploadUrlsResponseImageFileMetadata;
}

export interface ApiResponseCreateExpertOfferingImageUploadUrlsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: CreateExpertOfferingImageUploadUrlsResponse;
}

export interface CreateExpertOfferingOrderRequest {
  buyer: CreateOrderBuyerDto;
  entryAt: string;
  entryUrl?: string | null;
  payMetadata: CreateExpertOfferingOrderRequestDomesticPayMetadata;
  expertOffering: ExpertOfferingInfo;
  startedAtUTC?: string | null;
  endedAtUTC?: string | null;
}

export interface CreateExpertOfferingOrderRequestDomesticPayMetadata {
  payPgType: 'TOSS';
  payMethod: 'CARD' | 'NAVERPAY' | 'KAKAOPAY' | 'TOSSPAY' | 'INFPAY' | 'APPLEPAY' | 'PAYCO';
}

export interface ExpertOfferingInfo {
  id: number;
  regularPrice: number;
  paymentPrice: number;
}

export interface CreateExpertOfferingOrderResponse {
  id: number;
  merchantUid: string;
  title: string;
  buyer: CreateExpertOfferingOrderResponseBuyer;
  returnUrl: string;
}

export interface CreateExpertOfferingOrderResponseBuyer {
  email: string;
  phoneNumber: string;
  name: string;
  countryCode: string;
}

export interface ApiResponseCreateExpertOfferingOrderResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: CreateExpertOfferingOrderResponse;
}

export interface CommonTagResponse {
  id: number;
  title: string;
  subTitle: string;
  slug: string;
  isCuration: boolean;
}

export interface AddCartsRequest {
  courseIds: number[];
  fbclid?: string | null;
  eventId?: string | null;
}

export interface AddCartsResponse {
  items: AddCartDto[];
}

export interface AddCartDto {
  courseId: number;
  cartId: number;
}

export interface ApiResponseAddCartsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: AddCartsResponse;
}

export interface SubmitAxInquiryRequest {
  companyName: string;
  companySize:
    | 'ONE_FOUR'
    | 'FIVE_TEN'
    | 'ELEVEN_FIFTY'
    | 'FIFTY_ONE_TWO_HUNDRED'
    | 'TWO_HUNDRED_FIVE_HUNDRED'
    | 'FIVE_HUNDRED_THOUSAND'
    | 'THOUSAND_FIVE_THOUSAND'
    | 'TEN_THOUSAND'
    | 'TEN_THOUSAND_UPPER';
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  message: string;
  isPrivacyAgreed: boolean;
  isMarketingAgreed: boolean;
  source: 'AX_CLIENT_LANDING';
}

export interface UserAgent {
  rawUserAgent: string;
  isInflearnApp: boolean;
  isMobile: boolean;
}

export interface FindParentCategoryResponse {
  categories: ParentCategoryDto[];
}

export interface ParentCategoryDto {
  id: number;
  slug: string;
  title: string;
  originalTitle: string;
  icon: string;
}

export interface ApiResponseFindParentCategoryResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindParentCategoryResponse;
}

export interface ApiResponseOffsetPageResponseMyVoucherDto {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: OffsetPageResponseMyVoucherDto;
}

export interface MyVoucherChallengeCourseDto {
  id: number;
  hasSurveyAnswer: boolean;
  startedAt?: string;
  endedAt?: string;
  startedAtUTC: string;
  endedAtUTC: string;
}

export interface MyVoucherCourseDto {
  id: number;
  slug: string;
  title: string;
  lectureCount: number;
  thumbnailUrl: string;
  instructorId: number;
  instructorName: string;
  offlineCourse?: MyVoucherOfflineCourseDto;
  challengeCourse?: MyVoucherChallengeCourseDto;
  childCategories: string[];
}

export interface MyVoucherDto {
  id: number;
  userId: number;
  unitId: number;
  progress: string;
  completeCount: number;
  limitedAt?: string | null;
  isArchived: boolean;
  hasCertificate: boolean;
  type:
    | 'LEGACY'
    | 'IS_ADMIN'
    | 'BY_ADMIN'
    | 'IS_INSTRUCTOR'
    | 'BY_INSTRUCTOR'
    | 'FREE'
    | 'ORDER'
    | 'CODE'
    | 'GROUP_ORDER'
    | 'GROUP_SUBSCRIPTION'
    | 'COURSE_GIFT';
  cancelType?: 'B2B' | 'B2C';
  isArchivable: boolean;
  isReviewable: boolean;
  review?: MyVoucherReviewDto;
  course: MyVoucherCourseDto;
  limitedAtUTC?: string | null;
}

export interface MyVoucherOfflineCourseDto {
  id: number;
  startedAt: string;
  endedAt: string;
  hasSurveyAnswer: boolean;
  canAnswerSurvey: boolean;
  startedAtUTC: string;
  endedAtUTC: string;
}

export interface MyVoucherReviewDto {
  id: number;
  content: string;
  rating: number;
  reasons: string[];
}

export interface OffsetPageResponseMyVoucherDto {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyVoucherDto[];
}

export interface Requester {
  id: number;
  isAdmin: boolean;
  isBlacklist: boolean;
  isInstructor: boolean;
  isNotAdmin: boolean;
  isNotInstructor: boolean;
}

export interface ApiResponseListGetEnrollmentVerificationResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetEnrollmentVerificationResponse[] | null;
}

export interface GetEnrollmentVerificationResponse {
  id: number;
  courseId: number;
  courseSlug: string;
  courseTitle: string;
  courseThumbnailUrl: string;
  isConfirmed: boolean;
  createdAt: string;
  createdAtUTC: string;
}

export interface SearchSkillResponse {
  skills: SkillSummaryDto[];
}

export interface SkillSummaryDto {
  id: number;
  title: string;
  slug: string;
}

export interface ApiResponseSearchSkillResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchSkillResponse;
}

export interface FindMyListCoursesResponse {
  id: number;
  myListTitle?: MyListTitle;
  courses: FindMyListCourseInfo[];
  title: string;
}

export interface FindMyListCourseInfo {
  id: number;
  thumbnailUrl: string;
  courseTitle?: CourseTitle;
  slug: string;
  courseInstructorName?: string;
  courseInstructorSlug?: string | null;
  language?: 'KO' | 'EN' | 'JA' | 'VI';
  duration?: number | null;
  totalStar?: number;
  reviewCount?: number;
  tags: string[];
  lectureCount: number;
  canStudy: boolean;
  voucher?: FindMyListCourseVoucherInfo;
  title: string;
  expireInMonth?: number | null;
  rating: number;
  instructorName: string;
}

export interface FindMyListCourseVoucherInfo {
  limitedAt?: string | null;
  completedLectureCount: number;
  progress: number;
  lastUnitId?: number | null;
  limitedAtUTC?: string | null;
}

export interface ApiResponseFindMyListCoursesResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindMyListCoursesResponse;
}

export interface CourseTitle {
  desanitized?: string;
  sanitized?: string;
}

export interface MyListTitle {
  value: string;
  desanitized: string;
}

export interface CourseInstructorSimpleResponse {
  id: number;
  name: string;
  slug?: string | null;
}

export interface CourseSkillOneResponse {
  id: number;
  title: string;
  slug: string;
  subTitle: string;
}

export interface ChallengeCompletionCriterionResponse {
  type: 'LECTURE_PROGRESS_RATE' | 'MISSION_SUBMISSION_COUNT' | 'LIVE_ATTENDANCE_COUNT';
  target: number;
}

export interface BaseCourseChallengeResponse {
  startedAt?: string;
  endedAt?: string;
  applyStartedAt?: string;
  applyEndedAt?: string;
  applyClosedAt?: string | null;
  capacity: number;
  appliedStudentCount: number;
  displayRemainingApplicantCount?: number | null;
  hasSurveyAnswer: boolean;
  benefits: ChallengeBenefitResponse[];
  originalCourseId?: number | null;
  inquiryEmail?: string | null;
  inquiryLinkUrl?: string | null;
  openChatLink?: string | null;
  completionCriteria: ChallengeCompletionCriterionResponse[];
  cohort?: ChallengeCohortResponse;
  startedAtUTC: string;
  endedAtUTC: string;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  applyClosedAtUTC?: string | null;
}

export interface ChallengeBenefitResponse {
  title: string;
  type: string;
  iconType: string;
}

export interface ChallengeCohortResponse {
  cohortNumber: number;
  previousCohortCourseId?: number | null;
  previousCohortApplicantCount: number;
  previousCohortsApplicantCount: number;
  previousCohortPublicSubmissionCount: number;
  rootIsChallenge: boolean;
}

export interface CartResponse {
  id: number;
}

export interface GroupEnrolmentResponse {
  id: number;
}

export interface ReviewResponse {
  isShowing: boolean;
  count: number;
  averageStar: number;
}

export interface UnitSummaryResponse {
  lectureUnitCount: number;
  missionUnitCount: number;
  challengeUnitCount: number;
  liveSessionUnitCount: number;
  /**
   * previewVideoLectureCount를 사용해주세요
   */
  previewVideoUnitCount: number;
  previewUnitCount: number;
  previewVideoLectureCount: number;
  runtime: number;
  hasIntroVideo: boolean;
  totalPreviewVideoCount: number;
}

export interface CourseCategoryResponse {
  main: CourseCategoryTitleWithSlug;
  sub: CourseCategoryTitleWithSlug;
}

export interface CourseCategoryTitleWithSlug {
  title: string;
  slug: string;
}

export interface CourseLevelResponse {
  title: string;
  code: string;
  slug: string;
  isActive: boolean;
}

export interface CoursePaymentResponse {
  type:
    | 'ENROLLED'
    | 'PURCHASE_UNAVAILABLE'
    | 'B2B_SUBSCRIPTION'
    | 'B2B_ENROLMENT_PENDING'
    | 'B2B_PURCHASE'
    | 'B2B_PURCHASE_RESTRICTED'
    | 'FREE'
    | 'DISCOUNTED_PURCHASE'
    | 'REGULAR_PRICE_PURCHASE';
  regularPrice: number;
  payPrice: number;
  discountRate: number;
  discount?: CoursePaymentDiscountInfoResponse;
  group?: CoursePaymentResponseGroupResponse;
  krwRegularPrice: number;
  krwPaymentPrice: number;
}

export interface CoursePaymentDiscountInfoResponse {
  title: string;
  endedAt: string;
  type: 'COURSE' | 'USER' | 'PLATFORM' | 'MOCK_INTERVIEW' | 'COUPON' | 'NONE';
  discountId?: number | null;
  endedAtUTC: string;
}

export interface CoursePaymentResponseGroupResponse {
  name: string;
  approvalRequired: boolean;
  hidePrice: boolean;
}

export interface CourseCardItem {
  id: number;
  type: 'ON' | 'OFF' | 'CHALLENGE';
  tagTitles: string[];
  isHidePrice: boolean;
  hasMyReaction: boolean;
  hasMentoring: boolean;
  isKdt: boolean;
  offlineCourse?: CourseCardOfflineCourseResponse;
  challengeCourse?: CourseCardChallengeCourseResponse;
  course: CourseCardCourseResponse;
  instructor: CourseCardInstructorResponse;
  listPrice: CourseCardCoursePriceResponse;
  cart: CourseCardCartResponse;
  voucher?: CourseCardVoucherResponse;
  krwRegularPrice: number;
  krwPaymentPrice: number;
  topReviews: CourseCardBestReviewResponse[];
}

export interface CourseCardBestReviewResponse {
  id: number;
  rating: number;
  content: string;
  likeCount: number;
  userName: string;
}

export interface CourseCardCartResponse {
  isInCart: boolean;
  canUseCart: boolean;
}

export interface CourseCardChallengeCourseResponse {
  applyStartedAt?: string;
  applyEndedAt?: string;
  eventStartedAt?: string;
  eventEndedAt?: string;
  challengeStatus?:
    | 'BEFORE_APPLY'
    | 'APPLYING'
    | 'AFTER_APPLY'
    | 'PROCESSING'
    | 'PARTICIPATING'
    | 'COMPLETED';
  capacity: number;
  originalCourseStudentCount: number;
  applicantCount: number;
  canAnswerSurvey: boolean;
  hasSurveyAnswer: boolean;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  eventStartedAtUTC: string;
  eventEndedAtUTC: string;
}

export interface CourseCardCoursePriceResponse {
  isDiscount: boolean;
  isEarlyBirdDiscount: boolean;
  payPrice: number;
  regularPrice: number;
  isFree: boolean;
  discountRate: number;
  discountEndedAt?: string | null;
  discountId?: number | null;
  discountTitle?: string | null;
  discountEndedAtUTC?: string | null;
}

export interface CourseCardCourseResponse {
  id: number;
  slug: string;
  thumbnailUrl: string;
  title: string;
  description: string;
  reviewCount: number;
  studentCount: number;
  likeCount: number;
  star: number;
  isExclusive: boolean;
  isNew: boolean;
  isUpdated: boolean;
  updatedAt: string;
  publishedAt: string | null;
  metadata: SearchCourseMetadataResponse;
  abilities: string[];
  courseTags: CourseCardCourseResponseCourseTagResponse[];
  targets: string[];
  runtimeSecond: number;
  updatedAtUTC: string;
  publishedAtUTC?: string | null;
}

export interface CourseCardCourseResponseCourseTagResponse {
  tag:
    | 'IS_ACTIVE_IN_QUESTION'
    | 'IS_B2B_SUBSCRIPTION'
    | 'HAS_MISSION'
    | 'IS_CHALLENGE_APPLYING'
    | 'IS_CHALLENGE_BEFORE_APPLY'
    | 'IS_CHALLENGE_AFTER_APPLY'
    | 'IS_CHALLENGE_PROCESSING'
    | 'IS_CHALLENGE_COMPLETED'
    | 'IS_CHALLENGE_PARTICIPATING';
}

export interface CourseCardInstructorResponse {
  id: number;
  name: string;
  isInflearnGuaranteed: boolean;
}

export interface CourseCardOfflineCourseResponse {
  type: 'CONFERENCE' | 'CLASS';
  applyStartedAt: string;
  applyEndedAt: string;
  eventStartedAt: string;
  eventEndedAt: string;
  capacity: number;
  applicantCount: number;
  canAnswerSurvey: boolean;
  hasSurveyAnswer: boolean;
  applyStartedAtUTC: string;
  applyEndedAtUTC: string;
  eventStartedAtUTC: string;
  eventEndedAtUTC: string;
}

export interface CourseCardVoucherResponse {
  completeCount: number;
  lectureCount: number;
  progress: string;
}

export interface SearchCourseMetadataResponse {
  level: string;
  levelCode: string;
  /**
   * Use skillTags instead
   */
  skills: string[];
  skillTags: SearchCourseMetadataSkillTagResponse[];
  categories: CourseCardItemCourseCategoryResponse[];
  /**
   * Use categories instead
   */
  parentCategories: string[];
  /**
   * Use categories instead
   */
  childCategories: string[];
}

export interface CourseCardItemCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parent: SearchCourseMetadataResponseParentCategoryResponse;
}

export interface SearchCourseMetadataResponseParentCategoryResponse {
  id: number;
  title: string;
  slug: string;
}

export interface SearchCourseMetadataSkillTagResponse {
  id: number;
  title: string;
  slug: string;
}

export interface SearchCourseResponse {
  attributionToken: string;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[];
}

export interface ApiResponseSearchCourseResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchCourseResponse;
}

export interface ApiResponseFindMyUpcomingEventsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindMyUpcomingEventsResponse;
}

export interface FindMyUpcomingEventsResponse {
  items: UpcomingEventResponse[];
}

export interface UpcomingEventResponse {
  courseId: number;
  courseTitle: string;
  unitId: number;
  unitTitle: string;
  unitType: 'SECTION' | 'LECTURE' | 'MISSION' | 'DOCUMENT' | 'QUIZ' | 'LIVE_SESSION' | 'LABLUP';
  startedAtUTC?: string | null;
  endedAtUTC?: string | null;
}

export interface MyChallengeVoucherChallengeCourseDto {
  id: number;
  startedAt: string;
  endedAt: string;
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'ENDED';
  missions: MissionInfo[];
  liveSessions: LiveSessionInfo[];
  survey: SurveyInfo;
  startedAtUTC: string;
  endedAtUTC: string;
}

export interface LiveSessionInfo {
  id: number;
  unitId: number;
  title: string;
  startedAt: string;
  isParticipated: boolean;
  status: 'NOT_STARTED' | 'ROOM_OPENED' | 'ROOM_ENDED';
  startedAtUTC: string;
}

export interface MissionInfo {
  id: number;
  unitId: number;
  submissionStatus?: 'DRAFT' | 'REJECTED' | 'SUBMITTED' | 'ACCEPTED';
}

export interface SurveyInfo {
  hasSurveyAnswer: boolean;
}

export interface MyChallengeVoucherCourseDto {
  id: number;
  slug: string;
  title: string;
  lectureCount: number;
  thumbnailUrl: string;
  instructorId: number;
  instructorName: string;
  challengeCourse: MyChallengeVoucherChallengeCourseDto;
  childCategories: string[];
}

export interface MyChallengeVoucherDto {
  id: number;
  userId: number;
  unitId: number;
  progress: string;
  completeCount: number;
  limitedAt?: string | null;
  isArchived: boolean;
  hasCertificate: boolean;
  type:
    | 'LEGACY'
    | 'IS_ADMIN'
    | 'BY_ADMIN'
    | 'IS_INSTRUCTOR'
    | 'BY_INSTRUCTOR'
    | 'FREE'
    | 'ORDER'
    | 'CODE'
    | 'GROUP_ORDER'
    | 'GROUP_SUBSCRIPTION'
    | 'COURSE_GIFT';
  cancelType?: 'B2B' | 'B2C';
  isArchivable: boolean;
  isReviewable: boolean;
  review?: MyVoucherReviewDto;
  course: MyChallengeVoucherCourseDto;
  limitedAtUTC?: string | null;
}

export interface ApiResponseOffsetPageResponseMyChallengeVoucherDto {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: OffsetPageResponseMyChallengeVoucherDto;
}

export interface OffsetPageResponseMyChallengeVoucherDto {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyChallengeVoucherDto[];
}

export interface PageableObject {
  offset?: number;
  sort?: SortObject;
  paged?: boolean;
  pageSize?: number;
  pageNumber?: number;
  unpaged?: boolean;
}

export interface SortObject {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
}

export interface ApiResponseUserStatisticsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: UserStatisticsResponse;
}

export interface UserStatisticsResponse {
  userCourses: number[];
  userCourseCnt: number;
  userCourseTotalPaymentPrice: number;
  preferCategories: string[];
}

export interface RouletteResultsResponse {
  /**
   * 룰렛 추첨 이력 목록. 서비스데이 오름차순(과거순)
   */
  items: RouletteResultsResponseItem[];
}

export interface RouletteResultsResponseItem {
  resultType: 'PRIZE' | 'POINT';
  /**
   * 당첨 경품명. resultType=PRIZE 일 때만 존재하고, POINT 면 null
   */
  prizeName?: string | null;
  /**
   * 지급된 포인트. resultType=POINT 일 때만 존재하고, PRIZE 면 null
   */
  point?: number | null;
  /**
   * 추첨에 사용한 응모권의 서비스데이(새벽 4시 경계 발급 기준일)
   */
  serviceDate: string;
}

export interface ApiResponseRouletteResultsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: RouletteResultsResponse;
}

export interface RoadmapSummaryDto {
  id: number;
  title: string;
  likeCount: number;
  enrollCount: number;
  authorName: string;
  authorThumbnailUrl: string;
  thumbnailUrl: string;
  /**
   * Use authorName instead
   */
  userName: string;
  /**
   * Use thumbnailUrl instead
   */
  coverFileUrl: string;
}

export interface RoadmapsByAuthorResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: RoadmapSummaryDto[];
}

export interface ApiResponseRoadmapsByAuthorResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: RoadmapsByAuthorResponse;
}

export interface FindOrderSummaryResponse {
  items: OrderSummaryDto[];
  statistics: UserPurchaseStatisticsResult;
}

export interface OrderSummaryDto {
  id: number;
  title: string;
  createdAt: string;
  status:
    | 'CANCEL_DELETE'
    | 'MENTEE_CANCEL'
    | 'PARTIAL_CANCEL'
    | 'CANCEL_NOT_ENOUGH_PROGRESS'
    | 'GROUP_PAYMENT_CANCEL'
    | 'PAYMENT_CANCEL'
    | 'ORDER_FORM'
    | 'CONFLICT_CANCEL'
    | 'AUTO_CANCEL'
    | 'PAYMENT_READY'
    | 'TOTAL_CANCEL'
    | 'PAYMENT_FAIL'
    | 'PAYMENT_STOP'
    | 'CODE_ORDER'
    | 'ORDER_CANCEL'
    | 'PAYMENT_COMPLETE'
    | 'PAYMENT_COMPLETE_PROCESSING'
    | 'ADMIN_CANCEL'
    | 'MENTOR_CANCEL'
    | 'DEPOSIT_WAIT'
    | 'WC_COMPLETED'
    | 'MANUAL_DELETE'
    | 'REFUND_REQUEST';
  orderMode:
    | 'NORMAL'
    | 'B2B_CODE'
    | 'B2C_CODE'
    | 'CODE'
    | 'MENTOR'
    | 'MENTORING'
    | 'COURSE_GIFT'
    | 'CLIP'
    | 'COURSE_PACKAGE'
    | 'COURSE_SUBSCRIPTION'
    | 'MOCK_INTERVIEW'
    | 'EXPERT_OFFERING'
    | 'CUSTOM_PRODUCT'
    | 'BILLING';
  regularPrice: number;
  paymentPrice: number;
  itemsCount: number;
  receiptUrl: string;
  paymentChannel:
    | 'TOSS'
    | 'PAYMENTWALL'
    | 'TAZAPAY'
    | 'PAYPAL'
    | 'PAYLETTER'
    | 'IAMPORT'
    | 'NAVERPAY'
    | 'NONE'
    | 'TOSS_PAY';
  paymentMethodType?:
    | 'CARD'
    | 'NAVERPAY'
    | 'NAVERPAY_MONEY'
    | 'KAKAOPAY'
    | 'TOSSPAY'
    | 'TOSS_PAY_MONEY'
    | 'APPLEPAY'
    | 'VIRTUAL_ACCOUNT'
    | 'LIFE_EDUCATION'
    | 'OVERSEAS'
    | 'INFPAY'
    | 'BANK_TRANSFER'
    | 'PAYCO'
    | 'UNKNOWN'
    | 'NONE'
    | 'LINKPAY'
    | 'LINKPAY_NAVERPAY'
    | 'LINKPAY_KAKAOPAY'
    | 'LINKPAY_TOSSPAY'
    | 'LINKPAY_PAYCO'
    | 'LINKPAY_APPLEPAY'
    | 'LINKPAY_CARD'
    | 'LINKPAY_BANK_TRANSFER'
    | 'FPX'
    | 'SOFORT'
    | 'PAYNOW'
    | 'GRABPAYPH'
    | 'GRABPAYMY'
    | 'BOOST'
    | 'TOUCHNGO'
    | 'KONBINI'
    | 'PAYSHOP'
    | 'BANCONTACT'
    | 'EPS'
    | 'MULTIBANCO'
    | 'PRZELEWY24'
    | 'BLIK'
    | 'IDEAL'
    | 'PLATFORM'
    | 'POLI'
    | 'INSTANT_BANK_TRANSFER'
    | 'UPI';
  /**
   * use isReceiptAvailable
   */
  canGetReceipt: boolean;
  isReceiptAvailable: boolean;
  canGetInvoice: boolean;
  isOldDataWithNoReceipt: boolean;
  currency: 'KRW' | 'USD' | 'VND' | 'JPY';
  timezone: string;
  totalCourseAmount?: number | null;
  courseSubscription?: CourseSubscriptionSummary;
  createdAtUTC: string;
  isPaymentRequest: boolean;
}

export interface CourseSubscriptionSummary {
  groupId: number;
  startedAtUTC?: string | null;
  endedAtUTC?: string | null;
}

export interface UserPurchaseStatisticsResult {
  totalCount: number;
  totalOrderAmount: number;
  totalPaymentAmount: number;
  totalDiscountAmount: number;
}

export interface ApiResponseFindOrderSummaryResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindOrderSummaryResponse;
}

export interface FindMyListByCourseResponse {
  items: ItemResponse[];
}

export interface ItemResponse {
  id: number;
  title: string;
  hasCourse: boolean;
}

export interface ApiResponseFindMyListByCourseResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindMyListByCourseResponse;
}

export interface FindMyListResponse {
  id: number;
  title: string;
  courseCount: number;
}

export interface ApiResponseListFindMyListResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindMyListResponse[] | null;
}

export interface SearchPartnerCourseResponse {
  page?: PagePartnerCourseResponse;
  partner: SearchPartnerResponse;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: PartnerCourseResponse[];
}

export interface PartnerCourseResponse {
  course: PartnerCourseInfoResponse;
  listPrice: PartnerCoursePriceResponse;
  instructor: PartnerCourseInstructorResponse;
  commissionRate: number;
  expectedRevenue: number;
}

export interface PartnerCourseInfoResponse {
  id: number;
  slug: string;
  thumbnailUrl: string;
  title: string;
  description: string;
  reviewCount: number;
  studentCount: number;
  likeCount: number;
  star: number;
  updatedAt: string;
  publishedAt?: string | null;
  updatedAtUTC: string;
  publishedAtUTC?: string | null;
  metadata: PartnerCourseMetadataResponse;
  abilities: string[];
  targets: string[];
  runtimeSecond: number;
}

export interface PartnerCourseMetadataResponse {
  level: string;
  levelCode: string;
  skills: string[];
  skillTags: SearchPartnerCourseSkillTagResponse[];
  categories: SearchPartnerCourseCategoryResponse[];
}

export interface SearchPartnerCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parent: SearchPartnerCourseCategoryResponseParentCategoryResponse;
}

export interface SearchPartnerCourseCategoryResponseParentCategoryResponse {
  id: number;
  title: string;
  slug: string;
}

export interface SearchPartnerCourseSkillTagResponse {
  id: number;
  title: string;
  slug: string;
}

export interface PartnerCourseInstructorResponse {
  id: number;
  name: string;
}

export interface PartnerCoursePriceResponse {
  isDiscount: boolean;
  originalPrice: number;
  payPrice: number;
  regularPrice: number;
  discountRate: number;
  discountEndedAt?: string | null;
  discountEndedAtUTC?: string | null;
  discountId?: number | null;
  discountTitle?: string | null;
}

export interface SearchPartnerResponse {
  id: number;
  type: 'BUSINESS' | 'PERSONAL';
  commissionRate: CommissionRateResponse;
  hasSettlementInfo: boolean;
}

export interface CommissionRateResponse {
  agreed: number;
  disagreed: number;
}

export interface ApiResponseSearchPartnerCourseResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchPartnerCourseResponse;
}

export interface PagePartnerCourseResponse {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: PartnerCourseResponse[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface GetMarketingPartnerLinkCreatePreviewResponse {
  canCreate: boolean;
  commissionRate: number;
  attributeWindowDays: number;
}

export interface ApiResponseGetMarketingPartnerLinkCreatePreviewResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetMarketingPartnerLinkCreatePreviewResponse;
}

export interface SearchMyExpertProjectProposalsResponse {
  page?: PageMyProposalItem;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyProposalItem[];
}

export interface MyProposalItem {
  id: number;
  status: 'REVIEWING' | 'SELECTED' | 'NOT_SELECTED' | 'WITHDRAWN';
  project: ProjectSummary;
  price: number;
  workDays?: number | null;
  revision: number;
  updatedAt: string;
}

export interface ProjectSummary {
  id: number;
  /**
   * 의뢰 제목. 제목 입력 전에 접수된 기존 의뢰는 null
   */
  title?: string | null;
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  messagePreview: string;
  status: 'RECEIVED' | 'MATCHING' | 'PROPOSED' | 'MATCHED' | 'COMPLETED' | 'CLOSED' | 'CANCELLED';
  /**
   * false 면 어드민이 숨긴 의뢰. 제안서 수정은 막히고 철회만 가능하다
   */
  isExposed: boolean;
}

export interface ApiResponseSearchMyExpertProjectProposalsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchMyExpertProjectProposalsResponse;
}

export interface PageMyProposalItem {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: MyProposalItem[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface GetMyExpertProjectProposalResponse {
  id: number;
  status: 'REVIEWING' | 'SELECTED' | 'NOT_SELECTED' | 'WITHDRAWN';
  project: ProjectDetail;
  price: number;
  message: string;
  workDays?: number | null;
  revision: number;
  createdAt: string;
  updatedAt: string;
}

export interface ProjectDetail {
  id: number;
  /**
   * 의뢰 제목. 제목 입력 전에 접수된 기존 의뢰는 null
   */
  title?: string | null;
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  workMode?: 'REMOTE' | 'ONSITE' | 'NEGOTIABLE';
  /**
   * 진행 지역. 원격이면 null
   */
  workRegion?: string | null;
  /**
   * 교육 대상 인원. 교육이 포함된 패키지에서만 입력받는다
   */
  headcount?: number | null;
  message: string;
  createdAt: string;
  status: 'RECEIVED' | 'MATCHING' | 'PROPOSED' | 'MATCHED' | 'COMPLETED' | 'CLOSED' | 'CANCELLED';
  /**
   * false 면 어드민이 숨긴 의뢰. 제안서 수정은 막히고 철회만 가능하다
   */
  isExposed: boolean;
}

export interface ApiResponseGetMyExpertProjectProposalResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetMyExpertProjectProposalResponse;
}

export interface MyProposalResponse {
  id: number;
  status: 'REVIEWING' | 'SELECTED' | 'NOT_SELECTED' | 'WITHDRAWN';
}

export interface SearchOpenExpertProjectsResponse {
  page?: PageOpenExpertProjectItem;
  packageCounts: PackageCounts;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: OpenExpertProjectItem[];
}

export interface OpenExpertProjectItem {
  id: number;
  /**
   * 의뢰 제목. 제목 입력 전에 접수된 기존 의뢰는 null
   */
  title?: string | null;
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  workMode?: 'REMOTE' | 'ONSITE' | 'NEGOTIABLE';
  /**
   * 진행 지역. 원격이면 null
   */
  workRegion?: string | null;
  /**
   * 철회를 뺀 제안서 수
   */
  proposalCount: number;
  messagePreview: string;
  createdAt: string;
  myProposal?: MyProposalResponse;
}

export interface PackageCounts {
  /**
   * 전체 공개 의뢰 수. ALL 은 '패키지를 비교해 정하고 싶어요' 패키지의 수다
   */
  total: number;
  FULL: number;
  BUILD: number;
  EDUCATION: number;
  ALL: number;
}

export interface ApiResponseSearchOpenExpertProjectsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchOpenExpertProjectsResponse;
}

export interface PageOpenExpertProjectItem {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: OpenExpertProjectItem[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface GetOpenExpertProjectResponse {
  id: number;
  /**
   * 의뢰 제목. 제목 입력 전에 접수된 기존 의뢰는 null
   */
  title?: string | null;
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  workMode?: 'REMOTE' | 'ONSITE' | 'NEGOTIABLE';
  /**
   * 진행 지역. 원격이면 null
   */
  workRegion?: string | null;
  /**
   * 교육 대상 인원. 교육이 포함된 패키지에서만 입력받는다
   */
  headcount?: number | null;
  message: string;
  createdAt: string;
  myProposal?: MyProposalResponse;
  /**
   * 로그인한 사용자가 이 의뢰를 올린 기업이면 true. 비로그인이면 false
   */
  isMine: boolean;
}

export interface ApiResponseGetOpenExpertProjectResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetOpenExpertProjectResponse;
}

export interface SearchMyExpertProjectsResponse {
  page?: PageMyExpertProjectItem;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyExpertProjectItem[];
}

export interface MyExpertProjectItem {
  id: number;
  /**
   * 의뢰 제목. 제목 입력 전에 접수된 기존 의뢰는 null
   */
  title?: string | null;
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  messagePreview: string;
  status: 'RECEIVED' | 'MATCHING' | 'PROPOSED' | 'MATCHED' | 'COMPLETED' | 'CLOSED' | 'CANCELLED';
  /**
   * 어드민이 숨겼으면 false (비공개 처리됨)
   */
  isExposed: boolean;
  /**
   * 검토중·선택됨 제안서 수
   */
  proposalCount: number;
  /**
   * 기업이 제안서를 수락한 시각. 수락 전이면 null 이고, 수락 후 취소·종료돼도 남는다
   */
  matchedAt?: string | null;
  createdAt: string;
}

export interface ApiResponseSearchMyExpertProjectsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchMyExpertProjectsResponse;
}

export interface PageMyExpertProjectItem {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: MyExpertProjectItem[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface GetMyExpertProjectResponse {
  id: number;
  /**
   * 의뢰 제목. 제목 입력 전에 접수된 기존 의뢰는 null
   */
  title?: string | null;
  status: 'RECEIVED' | 'MATCHING' | 'PROPOSED' | 'MATCHED' | 'COMPLETED' | 'CLOSED' | 'CANCELLED';
  /**
   * 어드민이 숨겼으면 false (비공개 처리됨)
   */
  isExposed: boolean;
  companyName: string;
  companySize:
    | 'ONE_FOUR'
    | 'FIVE_TEN'
    | 'ELEVEN_FIFTY'
    | 'FIFTY_ONE_TWO_HUNDRED'
    | 'TWO_HUNDRED_FIVE_HUNDRED'
    | 'FIVE_HUNDRED_THOUSAND'
    | 'THOUSAND_FIVE_THOUSAND'
    | 'TEN_THOUSAND'
    | 'TEN_THOUSAND_UPPER';
  packageType: 'FULL' | 'BUILD' | 'EDUCATION' | 'ALL';
  timing?: 'WITHIN_ONE_MONTH' | 'ONE_TO_THREE_MONTHS' | 'THREE_TO_SIX_MONTHS' | 'NOT_DECIDED';
  desiredEndDate?: string | null;
  budgetRange?: 'UNDER_5M' | 'FROM_5M_TO_10M' | 'FROM_10M_TO_30M' | 'FROM_30M_TO_50M' | 'OVER_50M';
  workMode?: 'REMOTE' | 'ONSITE' | 'NEGOTIABLE';
  /**
   * 진행 지역. 원격이면 null
   */
  workRegion?: string | null;
  /**
   * 교육 대상 인원. 교육이 포함된 패키지에서만 입력받는다
   */
  headcount?: number | null;
  message: string;
  contactName: string;
  department?: string | null;
  position?: string | null;
  contactEmail: string;
  contactPhone: string;
  /**
   * 검토중·선택됨 제안서 수
   */
  proposalCount: number;
  /**
   * 수락한 제안서. 수락 전이면 null 이고, 수락 후 취소·종료돼도 이력으로 남는다
   */
  selectedProposalId?: number | null;
  /**
   * 기업이 제안서를 수락한 시각. 수락 전이면 null 이고, 수락 후 취소·종료돼도 남는다
   */
  matchedAt?: string | null;
  createdAt: string;
}

export interface ApiResponseGetMyExpertProjectResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetMyExpertProjectResponse;
}

export interface ExpertCardResponse {
  expertProfileId: number;
  name: string;
  /**
   * 인프런 프로필 사진. 등록하지 않았으면 null
   */
  profileImageUrl?: string | null;
  headline: string;
  /**
   * 대표 스킬 최대 5개
   */
  skills: ExpertSummaryResponseSkillTagResponse[];
  careerYears?: number | null;
  /**
   * 소속. 전문가가 공개를 허용했을 때만 내려가고 아니면 null
   */
  companyName?: string | null;
}

export interface ReceivedExpertProjectProposalResponse {
  id: number;
  status: 'REVIEWING' | 'SELECTED' | 'NOT_SELECTED' | 'WITHDRAWN';
  price: number;
  workDays?: number | null;
  messagePreview: string;
  revision: number;
  /**
   * 제출 시각. 수정해도 바뀌지 않는다
   */
  createdAt: string;
  updatedAt: string;
  expert: ExpertCardResponse;
}

export interface ApiResponseListReceivedExpertProjectProposalResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: ReceivedExpertProjectProposalResponse[] | null;
}

export interface ExpertDetailResponse {
  expertProfileId: number;
  name: string;
  /**
   * 인프런 프로필 사진. 등록하지 않았으면 null
   */
  profileImageUrl?: string | null;
  headline: string;
  skills: ExpertSummaryResponseSkillTagResponse[];
  careerYears?: number | null;
  /**
   * 소속. 전문가가 공개를 허용했을 때만 내려가고 아니면 null
   */
  companyName?: string | null;
  activityType: 'INDIVIDUAL' | 'TEAM';
  teamSize?: number | null;
  portfolioUrl?: string | null;
  priceUnit?: 'HOUR' | 'DAY' | 'PROJECT';
  priceMin?: number | null;
  priceMax?: number | null;
  isPriceNegotiable: boolean;
}

export interface GetReceivedExpertProjectProposalResponse {
  id: number;
  status: 'REVIEWING' | 'SELECTED' | 'NOT_SELECTED' | 'WITHDRAWN';
  price: number;
  message: string;
  workDays?: number | null;
  /**
   * 수락 요청에 그대로 보낸다
   */
  revision: number;
  createdAt: string;
  updatedAt: string;
  expert: ExpertDetailResponse;
}

export interface ApiResponseGetReceivedExpertProjectProposalResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetReceivedExpertProjectProposalResponse;
}

export interface GetExpertProfileResponse {
  id: number;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  rejectReason?: string | null;
  activityType: 'INDIVIDUAL' | 'TEAM';
  name: string;
  companyName?: string | null;
  isCompanyExposed: boolean;
  teamSize?: number | null;
  headline: string;
  skillTags: GetExpertProfileResponseSkillTagResponse[];
  careerYears?: number | null;
  portfolioUrl?: string | null;
  availableFrom?: 'IMMEDIATELY' | 'WITHIN_ONE_MONTH' | 'WITHIN_THREE_MONTHS' | 'NOT_DECIDED';
  weeklyHours?: number | null;
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  isPriceNegotiable: boolean;
  priceUnit?: 'HOUR' | 'DAY' | 'PROJECT';
  priceMin?: number | null;
  priceMax?: number | null;
  contactEmail: string;
  contactPhone: string;
  createdAt: string;
}

export interface GetExpertProfileResponseSkillTagResponse {
  id: number;
  name: string;
}

export interface ApiResponseGetExpertProfileResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetExpertProfileResponse;
}

export interface SearchExpertOfferingsResponse {
  page?: PageExpertOfferingItem;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: ExpertOfferingItem[];
}

export interface ExpertOfferingItem {
  id: number;
  title: string;
  thumbnailUrl?: string | null;
  price?: number | null;
  regularPrice?: number | null;
  workStyle?: 'REMOTE' | 'ONSITE' | 'HYBRID';
  estimatedPeriod?:
    | 'WEEK_1'
    | 'WEEK_2'
    | 'WEEK_3'
    | 'MONTH_1'
    | 'MONTH_2'
    | 'MONTH_3'
    | 'MONTH_6'
    | 'MONTH_6_PLUS';
  clientEffort?: 'NONE' | 'WEEKLY_1_2H' | 'WEEKLY_HALF_DAY' | 'WEEKLY_1_DAY_PLUS';
  categories: (
    | 'AUTOMATION'
    | 'CONTENT'
    | 'DATA'
    | 'CHATBOT'
    | 'RAG'
    | 'CONSULTING'
    | 'EDUCATION'
    | 'INTEGRATION'
    | 'MARKETING'
    | 'SALES'
    | 'HR'
    | 'FINANCE'
    | 'LEGAL'
    | 'RESEARCH'
    | 'VOICE'
    | 'VISION'
    | 'TRANSLATION'
    | 'SECURITY'
    | 'PROTOTYPE'
    | 'OTHER'
  )[];
  reviewSummary: ReviewSummaryResponse;
  bookmarkCount: number;
  expert: ExpertSummaryResponse;
  createdAt: string;
}

export interface ApiResponseSearchExpertOfferingsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchExpertOfferingsResponse;
}

export interface PageExpertOfferingItem {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: ExpertOfferingItem[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface SearchExpertOfferingReviewsResponse {
  page?: PageExpertOfferingReviewResponse;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: ExpertOfferingReviewResponse[];
}

export interface ApiResponseSearchExpertOfferingReviewsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchExpertOfferingReviewsResponse;
}

export interface PageExpertOfferingReviewResponse {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: ExpertOfferingReviewResponse[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface SearchMyExpertOfferingsResponse {
  page?: PageMyExpertOfferingItem;
  statusCounts: SearchMyExpertOfferingsResponseStatusCounts;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: MyExpertOfferingItem[];
}

export interface MyExpertOfferingItem {
  id: number;
  title: string;
  thumbnailUrl?: string | null;
  /**
   * 부가세 별도 가격(원)
   */
  price?: number | null;
  /**
   * 결제가(원, 부가세 포함)
   */
  regularPrice?: number | null;
  status: 'DRAFT' | 'PUBLISH' | 'PAUSE';
  /**
   * 공개에 필요한 내용(제목·설명)이 다 있는지. 전문가 프로필 승인 여부는 반영하지 않는다
   */
  isPublishable: boolean;
  /**
   * 어드민이 정하는 공개 목록 노출 여부
   */
  isExposed: boolean;
  createdAt: string;
  updatedAt: string;
  /**
   * 진행 전·진행 중(PAID·IN_PROGRESS) 이용권 수
   */
  activeVoucherCount: number;
  /**
   * 취소를 뺀 이용권 수
   */
  totalVoucherCount: number;
}

export interface SearchMyExpertOfferingsResponseStatusCounts {
  DRAFT: number;
  PUBLISH: number;
  PAUSE: number;
}

export interface ApiResponseSearchMyExpertOfferingsResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchMyExpertOfferingsResponse;
}

export interface PageMyExpertOfferingItem {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: MyExpertOfferingItem[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface SearchReceivedExpertOfferingVouchersResponse {
  page?: PageReceivedVoucherItem;
  statusCounts: SearchReceivedExpertOfferingVouchersResponseStatusCounts;
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: ReceivedVoucherItem[];
}

export interface SearchReceivedExpertOfferingVouchersResponseBuyer {
  /**
   * 표시용 이름. 탈퇴 등으로 없으면 null
   */
  name?: string | null;
}

export interface OfferingSummary {
  id: number;
  title: string;
  thumbnailUrl?: string | null;
  /**
   * 전문가가 삭제한 서비스인지. 삭제해도 종료·취소된 이용권은 목록에 남는다
   */
  isDeleted: boolean;
}

export interface ReceivedVoucherItem {
  id: number;
  status: 'PAID' | 'IN_PROGRESS' | 'ENDED' | 'CANCELED';
  offering?: OfferingSummary;
  buyer: SearchReceivedExpertOfferingVouchersResponseBuyer;
  /**
   * 결제 금액(원). 주문 스냅샷이 없으면 null
   */
  paymentPrice?: number | null;
  /**
   * 결제 완료(이용권 발급) 일시
   */
  paidAt: string;
  /**
   * 구매자가 고른 시작 일시. 진행 시작 시각이 아니다
   */
  startedAt?: string | null;
  /**
   * 구매자가 고른 종료 일시. 완료 시각이 아니다
   */
  endedAt?: string | null;
  canceledAt?: string | null;
}

export interface SearchReceivedExpertOfferingVouchersResponseStatusCounts {
  IN_PROGRESS: number;
  ENDED: number;
  CANCELED: number;
}

export interface ApiResponseSearchReceivedExpertOfferingVouchersResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: SearchReceivedExpertOfferingVouchersResponse;
}

export interface PageReceivedVoucherItem {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: ReceivedVoucherItem[];
  number?: number;
  last?: boolean;
  first?: boolean;
  sort?: SortObject;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface GetExpertOfferingOrderResponse {
  id: number;
  status:
    | 'CANCEL_DELETE'
    | 'MENTEE_CANCEL'
    | 'PARTIAL_CANCEL'
    | 'CANCEL_NOT_ENOUGH_PROGRESS'
    | 'GROUP_PAYMENT_CANCEL'
    | 'PAYMENT_CANCEL'
    | 'ORDER_FORM'
    | 'CONFLICT_CANCEL'
    | 'AUTO_CANCEL'
    | 'PAYMENT_READY'
    | 'TOTAL_CANCEL'
    | 'PAYMENT_FAIL'
    | 'PAYMENT_STOP'
    | 'CODE_ORDER'
    | 'ORDER_CANCEL'
    | 'PAYMENT_COMPLETE'
    | 'PAYMENT_COMPLETE_PROCESSING'
    | 'ADMIN_CANCEL'
    | 'MENTOR_CANCEL'
    | 'DEPOSIT_WAIT'
    | 'WC_COMPLETED'
    | 'MANUAL_DELETE'
    | 'REFUND_REQUEST';
  paidAtUTC?: string | null;
  payMethod: string;
  receiptUrl?: string | null;
  isReceiptAvailable: boolean;
  expertOfferingId: number;
  offeringTitle: string;
  regularPrice: number;
  paymentPrice: number;
  startedAtUTC?: string | null;
  endedAtUTC?: string | null;
  thumbnailUrl?: string | null;
  expert?: ExpertSummaryResponse;
  voucher?: GetExpertOfferingOrderResponseVoucherResponse;
  isRefundable: boolean;
}

export interface GetExpertOfferingOrderResponseVoucherResponse {
  id: number;
  status: 'PAID' | 'IN_PROGRESS' | 'ENDED' | 'CANCELED';
  canceledAtUTC?: string | null;
}

export interface ApiResponseGetExpertOfferingOrderResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetExpertOfferingOrderResponse;
}

export interface CourseSimpleOneResponse {
  id: number;
  title: string;
  type: 'ON' | 'OFF' | 'CHALLENGE';
  status: 'DRAFT' | 'PRIVATE' | 'SUBMIT' | 'PUBLISH' | 'PAUSE' | 'PUBLISH_READY';
  slug?: string | null;
  regularPrice?: number | null;
  duration?: number | null;
  studentCount: number;
  publishedAt?: string | null;
  submittedAt?: string | null;
  challengeCourse?: CourseSimpleOneResponseChallengeCourseResponse;
  submittedAtUTC?: string | null;
  publishedAtUTC?: string | null;
}

export interface CourseSimpleOneResponseChallengeCourseResponse {
  originalCourseId?: number | null;
}

export interface ApiResponseCourseSimpleOneResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: CourseSimpleOneResponse;
}

export interface CourseVoucherResponse {
  isValid: boolean;
  lastUnitId: number;
  progress: string;
  completeCount: number;
}

export interface GetCourseDetailInfoResponse {
  requestLanguage: 'KO' | 'EN' | 'JA' | 'VI';
  responseLanguage: 'KO' | 'EN' | 'JA' | 'VI';
  originalLanguage: 'KO' | 'EN' | 'JA' | 'VI';
  id: number;
  slug?: string | null;
  status: 'DRAFT' | 'PRIVATE' | 'SUBMIT' | 'PUBLISH' | 'PAUSE' | 'PUBLISH_READY';
  thumbnailUrl: string;
  isNew: boolean;
  isBest: boolean;
  title: string;
  studentCount: number;
  duration?: number | null;
  providesCertificate: boolean;
  providesInstructorAnswer: boolean;
  providesInquiry: boolean;
  isLiked: boolean;
  likeCount: number;
  description: string;
  unitSummary: UnitSummaryResponse;
  groupEnrolment?: GroupEnrolmentResponse;
  cart?: CartResponse;
  category: CourseCategoryResponse;
  voucher?: CourseVoucherResponse;
  paymentInfo: CoursePaymentResponse;
  review: ReviewResponse;
  instructors: CourseInstructorSimpleResponse[];
  levels: CourseLevelResponse[];
  skillTags: CourseSkillOneResponse[];
  publishedAt?: string | null;
  lastUpdatedAt?: string;
  commonTags: CommonTagResponse[];
  isGiftable?: boolean | null;
  isRequestGiftable: boolean;
  courseType: 'ON' | 'OFF' | 'CHALLENGE';
  challenge?: BaseCourseChallengeResponse;
  publishedAtUTC?: string | null;
  lastUpdatedAtUTC: string;
}

export interface ApiResponseGetCourseDetailInfoResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetCourseDetailInfoResponse;
}

export interface GetSubscriptionCoursesResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[];
}

export interface ApiResponseGetSubscriptionCoursesResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetSubscriptionCoursesResponse;
}

export interface UserProfileCourseResponse {
  totalPage: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  items: CourseCardItem[];
}

export interface ApiResponseUserProfileCourseResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: UserProfileCourseResponse;
}

export interface CourseByLikesResponse {
  items: CourseCardItem[];
}

export interface ApiResponseCourseByLikesResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: CourseByLikesResponse;
}

export interface FindSentCourseGiftResponse {
  items: FindSentCourseGiftItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPage: number;
}

export interface FindSentCourseGiftItem {
  id: number;
  receiptUrl: string;
  status: 'READY_TO_RECEIVE' | 'RECEIVED' | 'EXPIRED' | 'CANCELED';
  createdAt: string;
  orderTitle: string;
  courseTitle: string;
  courseSlug: string;
  receiverName: string;
  isDeletedCourse: boolean;
  isRefundable: boolean;
  refundLimitedAt: string;
  regularPrice: number;
  paymentPrice: number;
  currency: 'KRW' | 'USD' | 'VND' | 'JPY';
  timezone: string;
  paymentChannel:
    | 'TOSS'
    | 'PAYMENTWALL'
    | 'TAZAPAY'
    | 'PAYPAL'
    | 'PAYLETTER'
    | 'IAMPORT'
    | 'NAVERPAY'
    | 'NONE'
    | 'TOSS_PAY';
  isReceiptAvailable: boolean;
  isInvoiceAvailable: boolean;
  createdAtUTC: string;
  refundLimitedAtUTC?: string | null;
}

export interface ApiResponseFindSentCourseGiftResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindSentCourseGiftResponse;
}

export interface FindReceivedCourseGiftResponse {
  items: FindReceivedCourseGiftItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPage: number;
}

export interface FindReceivedCourseGiftItem {
  id: number;
  code: string;
  giftStatus?: 'READY_TO_RECEIVE' | 'RECEIVED' | 'EXPIRED' | 'CANCELED';
  giftPhotoCardId: number;
  giftPhotoCardImageUrl: string;
  createdAt: string;
  orderTitle: string;
  courseTitle: string;
  courseSlug: string;
  isDeletedCourse: boolean;
  senderName: string;
  limitedAt?: string | null;
  canceledAt?: string | null;
  approvedAt: string;
  duration?: number | null;
  createdAtUTC: string;
  limitedAtUTC?: string | null;
  approvedAtUTC: string;
  canceledAtUTC?: string | null;
  isCanceled: boolean;
  status: 'RECEIVED' | 'CANCELED';
}

export interface ApiResponseFindReceivedCourseGiftResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindReceivedCourseGiftResponse;
}

export interface GetCertificatesResponse {
  userId: number;
  voucherId: number;
  courseId: number;
  courseSlug: string;
  courseTitle: string;
  courseType: 'ON' | 'OFF' | 'CHALLENGE';
  courseThumbnailUrl: string;
  certificateConfirmedAt?: string | null;
  certificatedAt?: string | null;
  certificateConfirmedAtUTC?: string | null;
  certificatedAtUTC?: string | null;
}

export interface ApiResponseListGetCertificatesResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetCertificatesResponse[] | null;
}

export interface UnconfirmedResponse {
  hasUnconfirmedCertificate: boolean;
}

export interface ApiResponseUnconfirmedResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: UnconfirmedResponse;
}

export interface GetCertificateDetailResponse {
  userId: number;
  courseId: number;
  voucherId: number;
  realName: string;
  title: string;
  runtime: number;
  instructorName: string;
  startedAt: string;
  certificatedAt: string;
  startedAtUTC: string;
  certificatedAtUTC: string;
}

export interface ApiResponseGetCertificateDetailResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: GetCertificateDetailResponse;
}

export interface FindClientCartResponse {
  items: ClientCartItemDto[];
  now: string;
  nowUTC: string;
}

export interface ChallengeCartResponse {
  startedAt?: string;
  endedAt?: string;
  applyStartedAt?: string;
  startedAtUTC: string;
  endedAtUTC: string;
  applyStartedAtUTC: string;
}

export interface ClientCartItemDto {
  id: number;
  courseId: number;
  slug: string;
  title: string;
  duration?: number | null;
  thumbnailUrl: string;
  regularPrice: number;
  paymentPrice: number;
  krwRegularPrice: number;
  krwPaymentPrice: number;
  usdRegularPrice: number;
  usdPaymentPrice: number;
  publishedAt?: string | null;
  updatedAt?: string | null;
  discount?: FindClientCartResponseDiscountDto;
  isPromotion: boolean;
  type: 'ON' | 'OFF' | 'CHALLENGE';
  studentCount: number;
  reviewCount: number;
  reviewAverage: number;
  likeCount: number;
  level?: FindClientCartResponseCourseLevelResponse;
  categories: FindClientCartCourseCategoryResponse[];
  skills: FindClientCartResponseCourseSkillResponse[];
  instructorId: number;
  instructorName: string;
  kdtPrice?: number | null;
  currency: 'KRW' | 'USD' | 'VND' | 'JPY';
  challenge?: ChallengeCartResponse;
  isMcpCourse: boolean;
  publishedAtUTC: string;
  updatedAtUTC: string;
}

export interface FindClientCartResponseCourseLevelResponse {
  id: number;
  title: string;
  code: string;
}

export interface FindClientCartResponseCourseSkillResponse {
  id: number;
  title: string;
  slug: string;
}

export interface FindClientCartResponseDiscountDto {
  id?: number | null;
  title: string;
  discountStrategy: 'PERCENT' | 'PRICE';
  type: 'COURSE' | 'USER' | 'PLATFORM' | 'MOCK_INTERVIEW' | 'COUPON' | 'NONE';
  endedAt: string;
  discountRate: number;
  discountPrice: number;
  usdDiscountPrice: number;
  endedAtUTC: string;
}

export interface FindClientCartCourseCategoryResponse {
  id: number;
  title: string;
  slug: string;
  parent: FindClientCartResponseParentCategoryResponse;
}

export interface FindClientCartResponseParentCategoryResponse {
  id: number;
  title: string;
  slug: string;
}

export interface ApiResponseFindClientCartResponse {
  statusCode:
    | 'OK'
    | 'CREATED'
    | 'BAD_REQUEST'
    | 'NOT_FOUND'
    | 'INTERNAL_SERVER_ERROR'
    | 'FORBIDDEN'
    | 'CONFLICT'
    | 'UNAUTHORIZED'
    | 'PAYLOAD_TOO_LARGE'
    | 'TOO_MANY_REQUESTS';
  message: string;
  errorCode?: string | null;
  data: FindClientCartResponse;
}

export interface RemoveCourseRequest {
  listId: number;
  courseId: number;
}

export interface RemoveCartsRequest {
  courseIds: number[];
}

/** ExpertPackageType */
export const enum ExpertPackageType {
  FULL = 'FULL',
  BUILD = 'BUILD',
  EDUCATION = 'EDUCATION',
  ALL = 'ALL',
}

/** ExpertProjectOpenSort */
export const enum ExpertProjectOpenSort {
  LATEST = 'LATEST',
  BUDGET_DESC = 'BUDGET_DESC',
  FEWEST_PROPOSALS = 'FEWEST_PROPOSALS',
}

/** ExpertOfferingSort */
export const enum ExpertOfferingSort {
  LATEST = 'LATEST',
  LOWEST_PRICE = 'LOWEST_PRICE',
  HIGHEST_PRICE = 'HIGHEST_PRICE',
}

/** CourseType */
export const enum CourseType {
  ON = 'ON',
  OFF = 'OFF',
  CHALLENGE = 'CHALLENGE',
}

/** MyVoucherStudyingType */
export const enum MyVoucherStudyingType {
  STUDYING = 'STUDYING',
  COMPLETED = 'COMPLETED',
}

/** MyVouchersSortType */
export const enum MyVouchersSortType {
  COURSE_TITLE = 'COURSE_TITLE',
  RECENT_STUDYING = 'RECENT_STUDYING',
  RECENT_APPLY = 'RECENT_APPLY',
  EARLIEST_EXPIRATION = 'EARLIEST_EXPIRATION',
}

/** Language */
export const enum Language {
  KO = 'KO',
  EN = 'EN',
  JA = 'JA',
  VI = 'VI',
}

/** MyVoucherChallengeStudyingType */
export const enum MyVoucherChallengeStudyingType {
  STUDYING = 'STUDYING',
}

/** MyChallengeVouchersOffsetSortType */
export const enum MyChallengeVouchersOffsetSortType {
  COURSE_TITLE = 'COURSE_TITLE',
  RECENT_STUDYING = 'RECENT_STUDYING',
  RECENT_APPLY = 'RECENT_APPLY',
}

/** SearchPartnerCourseSort */
export const enum SearchPartnerCourseSort {
  POPULAR = 'POPULAR',
  RECENT = 'RECENT',
  PRICE = 'PRICE',
  REVENUE = 'REVENUE',
  MARGIN = 'MARGIN',
  REVIEW = 'REVIEW',
  STUDENT = 'STUDENT',
  RATING = 'RATING',
}

/** ExpertProjectProposalStatus */
export const enum ExpertProjectProposalStatus {
  REVIEWING = 'REVIEWING',
  SELECTED = 'SELECTED',
  NOT_SELECTED = 'NOT_SELECTED',
  WITHDRAWN = 'WITHDRAWN',
}

/** ExpertProjectStatus */
export const enum ExpertProjectStatus {
  RECEIVED = 'RECEIVED',
  MATCHING = 'MATCHING',
  PROPOSED = 'PROPOSED',
  MATCHED = 'MATCHED',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

/** ExpertOfferingStatus */
export const enum ExpertOfferingStatus {
  DRAFT = 'DRAFT',
  PUBLISH = 'PUBLISH',
  PAUSE = 'PAUSE',
}

/** ExpertOfferingVoucherStatus */
export const enum ExpertOfferingVoucherStatus {
  PAID = 'PAID',
  IN_PROGRESS = 'IN_PROGRESS',
  ENDED = 'ENDED',
  CANCELED = 'CANCELED',
}

/** GetUserProfileCourseSort */
export const enum GetUserProfileCourseSort {
  RECENT = 'RECENT',
  POPULAR = 'POPULAR',
  RECOMMEND = 'RECOMMEND',
}

/** LikedCourseSort */
export const enum LikedCourseSort {
  RECENT = 'RECENT',
  TITLE = 'TITLE',
  STUDENT = 'STUDENT',
  RATING = 'RATING',
}

/** LikedCourseChargeType */
export const enum LikedCourseChargeType {
  FREE = 'FREE',
  PAID = 'PAID',
  ALL = 'ALL',
}

/** CourseCertificateSortType */
export const enum CourseCertificateSortType {
  CERTIFICATED = 'CERTIFICATED',
  CONFIRMED = 'CONFIRMED',
}

/** ExpertActivityType */
export const enum ExpertActivityType {
  INDIVIDUAL = 'INDIVIDUAL',
  TEAM = 'TEAM',
}

/** ExpertAvailableFrom */
export const enum ExpertAvailableFrom {
  IMMEDIATELY = 'IMMEDIATELY',
  WITHIN_ONE_MONTH = 'WITHIN_ONE_MONTH',
  WITHIN_THREE_MONTHS = 'WITHIN_THREE_MONTHS',
  NOT_DECIDED = 'NOT_DECIDED',
}

/** ExpertWorkStyle */
export const enum ExpertWorkStyle {
  REMOTE = 'REMOTE',
  ONSITE = 'ONSITE',
  HYBRID = 'HYBRID',
}

/** ExpertPriceUnit */
export const enum ExpertPriceUnit {
  HOUR = 'HOUR',
  DAY = 'DAY',
  PROJECT = 'PROJECT',
}

export const enum StatusCode {
  OK = 'OK',
  CREATED = 'CREATED',
  BAD_REQUEST = 'BAD_REQUEST',
  NOT_FOUND = 'NOT_FOUND',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  FORBIDDEN = 'FORBIDDEN',
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
}

/** ExpertOfferingCategoryType */
export const enum ExpertOfferingCategoryType {
  AUTOMATION = 'AUTOMATION',
  CONTENT = 'CONTENT',
  DATA = 'DATA',
  CHATBOT = 'CHATBOT',
  RAG = 'RAG',
  CONSULTING = 'CONSULTING',
  EDUCATION = 'EDUCATION',
  INTEGRATION = 'INTEGRATION',
  MARKETING = 'MARKETING',
  SALES = 'SALES',
  HR = 'HR',
  FINANCE = 'FINANCE',
  LEGAL = 'LEGAL',
  RESEARCH = 'RESEARCH',
  VOICE = 'VOICE',
  VISION = 'VISION',
  TRANSLATION = 'TRANSLATION',
  SECURITY = 'SECURITY',
  PROTOTYPE = 'PROTOTYPE',
  OTHER = 'OTHER',
}

/** ExpertOfferingEstimatedPeriod */
export const enum ExpertOfferingEstimatedPeriod {
  WEEK_1 = 'WEEK_1',
  WEEK_2 = 'WEEK_2',
  WEEK_3 = 'WEEK_3',
  MONTH_1 = 'MONTH_1',
  MONTH_2 = 'MONTH_2',
  MONTH_3 = 'MONTH_3',
  MONTH_6 = 'MONTH_6',
  MONTH_6_PLUS = 'MONTH_6_PLUS',
}

/** ExpertOfferingClientEffort */
export const enum ExpertOfferingClientEffort {
  NONE = 'NONE',
  WEEKLY_1_2H = 'WEEKLY_1_2H',
  WEEKLY_HALF_DAY = 'WEEKLY_HALF_DAY',
  WEEKLY_1_DAY_PLUS = 'WEEKLY_1_DAY_PLUS',
}

/** 저장할 상태. DRAFT(작성 중)·PUBLISH(공개). 일시 중지된 서비스는 PAUSE 로 그대로 저장할 수 있다 */
export const enum 저장할상태DRAFT작성중·PUBLISH공개일시중지된서비스는PAUSE로그대로저장할수있다 {
  DRAFT = 'DRAFT',
  PUBLISH = 'PUBLISH',
  PAUSE = 'PAUSE',
}

/** ExpertOfferingVoucherCancelReasonType */
export const enum ExpertOfferingVoucherCancelReasonType {
  PAYMENT_METHOD_CHANGE = 'PAYMENT_METHOD_CHANGE',
  DISCOUNT = 'DISCOUNT',
  CHANGE_MIND = 'CHANGE_MIND',
  DISSATISFACTION = 'DISSATISFACTION',
  ETC = 'ETC',
}

/** 추첨 결과 유형 (PRIZE: 경품 당첨, POINT: 포인트 지급). 이 값에 따라 prizeName / point 중 하나만 채워진다. */
export const enum 추첨결과유형PRIZE경품당첨POINT포인트지급이값에따라PrizeNamePoint중하나만채워진다 {
  PRIZE = 'PRIZE',
  POINT = 'POINT',
}

/** MarketingPartnerType */
export const enum MarketingPartnerType {
  BUSINESS = 'BUSINESS',
  PERSONAL = 'PERSONAL',
}

/** ExpertCompanySize */
export const enum ExpertCompanySize {
  ONE_FOUR = 'ONE_FOUR',
  FIVE_TEN = 'FIVE_TEN',
  ELEVEN_FIFTY = 'ELEVEN_FIFTY',
  FIFTY_ONE_TWO_HUNDRED = 'FIFTY_ONE_TWO_HUNDRED',
  TWO_HUNDRED_FIVE_HUNDRED = 'TWO_HUNDRED_FIVE_HUNDRED',
  FIVE_HUNDRED_THOUSAND = 'FIVE_HUNDRED_THOUSAND',
  THOUSAND_FIVE_THOUSAND = 'THOUSAND_FIVE_THOUSAND',
  TEN_THOUSAND = 'TEN_THOUSAND',
  TEN_THOUSAND_UPPER = 'TEN_THOUSAND_UPPER',
}

/** ExpertProjectTiming */
export const enum ExpertProjectTiming {
  WITHIN_ONE_MONTH = 'WITHIN_ONE_MONTH',
  ONE_TO_THREE_MONTHS = 'ONE_TO_THREE_MONTHS',
  THREE_TO_SIX_MONTHS = 'THREE_TO_SIX_MONTHS',
  NOT_DECIDED = 'NOT_DECIDED',
}

/** ExpertProjectBudgetRange */
export const enum ExpertProjectBudgetRange {
  UNDER_5M = 'UNDER_5M',
  FROM_5M_TO_10M = 'FROM_5M_TO_10M',
  FROM_10M_TO_30M = 'FROM_10M_TO_30M',
  FROM_30M_TO_50M = 'FROM_30M_TO_50M',
  OVER_50M = 'OVER_50M',
}

/** ExpertProjectWorkMode */
export const enum ExpertProjectWorkMode {
  REMOTE = 'REMOTE',
  ONSITE = 'ONSITE',
  NEGOTIABLE = 'NEGOTIABLE',
}

/** ExpertOfferingOrderPgType */
export const enum ExpertOfferingOrderPgType {
  TOSS = 'TOSS',
}

/** ExpertOfferingOrderPayMethod */
export const enum ExpertOfferingOrderPayMethod {
  CARD = 'CARD',
  NAVERPAY = 'NAVERPAY',
  KAKAOPAY = 'KAKAOPAY',
  TOSSPAY = 'TOSSPAY',
  INFPAY = 'INFPAY',
  APPLEPAY = 'APPLEPAY',
  PAYCO = 'PAYCO',
}

/** AxInquirySource */
export const enum AxInquirySource {
  AX_CLIENT_LANDING = 'AX_CLIENT_LANDING',
}

/** VoucherType */
export const enum VoucherType {
  LEGACY = 'LEGACY',
  IS_ADMIN = 'IS_ADMIN',
  BY_ADMIN = 'BY_ADMIN',
  IS_INSTRUCTOR = 'IS_INSTRUCTOR',
  BY_INSTRUCTOR = 'BY_INSTRUCTOR',
  FREE = 'FREE',
  ORDER = 'ORDER',
  CODE = 'CODE',
  GROUP_ORDER = 'GROUP_ORDER',
  GROUP_SUBSCRIPTION = 'GROUP_SUBSCRIPTION',
  COURSE_GIFT = 'COURSE_GIFT',
}

/** CancelType */
export const enum CancelType {
  B2B = 'B2B',
  B2C = 'B2C',
}

/** ChallengeCompletionCriterionType */
export const enum ChallengeCompletionCriterionType {
  LECTURE_PROGRESS_RATE = 'LECTURE_PROGRESS_RATE',
  MISSION_SUBMISSION_COUNT = 'MISSION_SUBMISSION_COUNT',
  LIVE_ATTENDANCE_COUNT = 'LIVE_ATTENDANCE_COUNT',
}

/** CoursePaymentInfoType */
export const enum CoursePaymentInfoType {
  ENROLLED = 'ENROLLED',
  PURCHASE_UNAVAILABLE = 'PURCHASE_UNAVAILABLE',
  B2B_SUBSCRIPTION = 'B2B_SUBSCRIPTION',
  B2B_ENROLMENT_PENDING = 'B2B_ENROLMENT_PENDING',
  B2B_PURCHASE = 'B2B_PURCHASE',
  B2B_PURCHASE_RESTRICTED = 'B2B_PURCHASE_RESTRICTED',
  FREE = 'FREE',
  DISCOUNTED_PURCHASE = 'DISCOUNTED_PURCHASE',
  REGULAR_PRICE_PURCHASE = 'REGULAR_PRICE_PURCHASE',
}

/** DiscountType */
export const enum DiscountType {
  COURSE = 'COURSE',
  USER = 'USER',
  PLATFORM = 'PLATFORM',
  MOCK_INTERVIEW = 'MOCK_INTERVIEW',
  COUPON = 'COUPON',
  NONE = 'NONE',
}

/** ChallengeStatus */
export const enum ChallengeStatus {
  BEFORE_APPLY = 'BEFORE_APPLY',
  APPLYING = 'APPLYING',
  AFTER_APPLY = 'AFTER_APPLY',
  PROCESSING = 'PROCESSING',
  PARTICIPATING = 'PARTICIPATING',
  COMPLETED = 'COMPLETED',
}

/** CourseCardTag */
export const enum CourseCardTag {
  IS_ACTIVE_IN_QUESTION = 'IS_ACTIVE_IN_QUESTION',
  IS_B2B_SUBSCRIPTION = 'IS_B2B_SUBSCRIPTION',
  HAS_MISSION = 'HAS_MISSION',
  IS_CHALLENGE_APPLYING = 'IS_CHALLENGE_APPLYING',
  IS_CHALLENGE_BEFORE_APPLY = 'IS_CHALLENGE_BEFORE_APPLY',
  IS_CHALLENGE_AFTER_APPLY = 'IS_CHALLENGE_AFTER_APPLY',
  IS_CHALLENGE_PROCESSING = 'IS_CHALLENGE_PROCESSING',
  IS_CHALLENGE_COMPLETED = 'IS_CHALLENGE_COMPLETED',
  IS_CHALLENGE_PARTICIPATING = 'IS_CHALLENGE_PARTICIPATING',
}

/** OfflineCourseType */
export const enum OfflineCourseType {
  CONFERENCE = 'CONFERENCE',
  CLASS = 'CLASS',
}

/** UnitType */
export const enum UnitType {
  SECTION = 'SECTION',
  LECTURE = 'LECTURE',
  MISSION = 'MISSION',
  DOCUMENT = 'DOCUMENT',
  QUIZ = 'QUIZ',
  LIVE_SESSION = 'LIVE_SESSION',
  LABLUP = 'LABLUP',
}

/** ChallengeCourseViewStatus */
export const enum ChallengeCourseViewStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  ENDED = 'ENDED',
}

/** LiveSessionStatus */
export const enum LiveSessionStatus {
  NOT_STARTED = 'NOT_STARTED',
  ROOM_OPENED = 'ROOM_OPENED',
  ROOM_ENDED = 'ROOM_ENDED',
}

/** SubmissionStatus */
export const enum SubmissionStatus {
  DRAFT = 'DRAFT',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED',
  ACCEPTED = 'ACCEPTED',
}

/** OrderStatus */
export const enum OrderStatus {
  CANCEL_DELETE = 'CANCEL_DELETE',
  MENTEE_CANCEL = 'MENTEE_CANCEL',
  PARTIAL_CANCEL = 'PARTIAL_CANCEL',
  CANCEL_NOT_ENOUGH_PROGRESS = 'CANCEL_NOT_ENOUGH_PROGRESS',
  GROUP_PAYMENT_CANCEL = 'GROUP_PAYMENT_CANCEL',
  PAYMENT_CANCEL = 'PAYMENT_CANCEL',
  ORDER_FORM = 'ORDER_FORM',
  CONFLICT_CANCEL = 'CONFLICT_CANCEL',
  AUTO_CANCEL = 'AUTO_CANCEL',
  PAYMENT_READY = 'PAYMENT_READY',
  TOTAL_CANCEL = 'TOTAL_CANCEL',
  PAYMENT_FAIL = 'PAYMENT_FAIL',
  PAYMENT_STOP = 'PAYMENT_STOP',
  CODE_ORDER = 'CODE_ORDER',
  ORDER_CANCEL = 'ORDER_CANCEL',
  PAYMENT_COMPLETE = 'PAYMENT_COMPLETE',
  PAYMENT_COMPLETE_PROCESSING = 'PAYMENT_COMPLETE_PROCESSING',
  ADMIN_CANCEL = 'ADMIN_CANCEL',
  MENTOR_CANCEL = 'MENTOR_CANCEL',
  DEPOSIT_WAIT = 'DEPOSIT_WAIT',
  WC_COMPLETED = 'WC_COMPLETED',
  MANUAL_DELETE = 'MANUAL_DELETE',
  REFUND_REQUEST = 'REFUND_REQUEST',
}

/** OrderMode */
export const enum OrderMode {
  NORMAL = 'NORMAL',
  B2B_CODE = 'B2B_CODE',
  B2C_CODE = 'B2C_CODE',
  CODE = 'CODE',
  MENTOR = 'MENTOR',
  MENTORING = 'MENTORING',
  COURSE_GIFT = 'COURSE_GIFT',
  CLIP = 'CLIP',
  COURSE_PACKAGE = 'COURSE_PACKAGE',
  COURSE_SUBSCRIPTION = 'COURSE_SUBSCRIPTION',
  MOCK_INTERVIEW = 'MOCK_INTERVIEW',
  EXPERT_OFFERING = 'EXPERT_OFFERING',
  CUSTOM_PRODUCT = 'CUSTOM_PRODUCT',
  BILLING = 'BILLING',
}

/** PaymentChannel */
export const enum PaymentChannel {
  TOSS = 'TOSS',
  PAYMENTWALL = 'PAYMENTWALL',
  TAZAPAY = 'TAZAPAY',
  PAYPAL = 'PAYPAL',
  PAYLETTER = 'PAYLETTER',
  IAMPORT = 'IAMPORT',
  NAVERPAY = 'NAVERPAY',
  NONE = 'NONE',
  TOSS_PAY = 'TOSS_PAY',
}

/** MethodType */
export const enum MethodType {
  CARD = 'CARD',
  NAVERPAY = 'NAVERPAY',
  NAVERPAY_MONEY = 'NAVERPAY_MONEY',
  KAKAOPAY = 'KAKAOPAY',
  TOSSPAY = 'TOSSPAY',
  TOSS_PAY_MONEY = 'TOSS_PAY_MONEY',
  APPLEPAY = 'APPLEPAY',
  VIRTUAL_ACCOUNT = 'VIRTUAL_ACCOUNT',
  LIFE_EDUCATION = 'LIFE_EDUCATION',
  OVERSEAS = 'OVERSEAS',
  INFPAY = 'INFPAY',
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAYCO = 'PAYCO',
  UNKNOWN = 'UNKNOWN',
  NONE = 'NONE',
  LINKPAY = 'LINKPAY',
  LINKPAY_NAVERPAY = 'LINKPAY_NAVERPAY',
  LINKPAY_KAKAOPAY = 'LINKPAY_KAKAOPAY',
  LINKPAY_TOSSPAY = 'LINKPAY_TOSSPAY',
  LINKPAY_PAYCO = 'LINKPAY_PAYCO',
  LINKPAY_APPLEPAY = 'LINKPAY_APPLEPAY',
  LINKPAY_CARD = 'LINKPAY_CARD',
  LINKPAY_BANK_TRANSFER = 'LINKPAY_BANK_TRANSFER',
  FPX = 'FPX',
  SOFORT = 'SOFORT',
  PAYNOW = 'PAYNOW',
  GRABPAYPH = 'GRABPAYPH',
  GRABPAYMY = 'GRABPAYMY',
  BOOST = 'BOOST',
  TOUCHNGO = 'TOUCHNGO',
  KONBINI = 'KONBINI',
  PAYSHOP = 'PAYSHOP',
  BANCONTACT = 'BANCONTACT',
  EPS = 'EPS',
  MULTIBANCO = 'MULTIBANCO',
  PRZELEWY24 = 'PRZELEWY24',
  BLIK = 'BLIK',
  IDEAL = 'IDEAL',
  PLATFORM = 'PLATFORM',
  POLI = 'POLI',
  INSTANT_BANK_TRANSFER = 'INSTANT_BANK_TRANSFER',
  UPI = 'UPI',
}

/** CurrencyCode */
export const enum CurrencyCode {
  KRW = 'KRW',
  USD = 'USD',
  VND = 'VND',
  JPY = 'JPY',
}

/** ExpertProfileStatus */
export const enum ExpertProfileStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

/** 원래 상태. PAID 도 화면에서는 진행 중으로 보여 준다 */
export const enum 원래상태PAID도화면에서는진행중으로보여준다 {
  PAID = 'PAID',
  IN_PROGRESS = 'IN_PROGRESS',
  ENDED = 'ENDED',
  CANCELED = 'CANCELED',
}

/** CourseStatus */
export const enum CourseStatus {
  DRAFT = 'DRAFT',
  PRIVATE = 'PRIVATE',
  SUBMIT = 'SUBMIT',
  PUBLISH = 'PUBLISH',
  PAUSE = 'PAUSE',
  PUBLISH_READY = 'PUBLISH_READY',
}

/** CourseGiftStatus */
export const enum CourseGiftStatus {
  READY_TO_RECEIVE = 'READY_TO_RECEIVE',
  RECEIVED = 'RECEIVED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}

/** CourseGiftResponseStatus */
export const enum CourseGiftResponseStatus {
  RECEIVED = 'RECEIVED',
  CANCELED = 'CANCELED',
}

/** DiscountStrategy */
export const enum DiscountStrategy {
  PERCENT = 'PERCENT',
  PRICE = 'PRICE',
}
